export default {
  system: {
    name: '卖家端',
    home: '仪表盘',
    signOut: '退出',
    myAccount: '账号中心',
    systemLanguage: '系统语言',
    login: '登录',
    passwordLogin: '密码登录',
    smsLogin: '验证码登录',
    sendCode: '获取验证码',
    retrySending: '重新获取',
    loginTips: '首次登录或未绑定手机号请选择密码登录',
    loggedOut: '登录已过期，请重新登录或返回首页',
    confirmLogout: '确定登出',
    welcomeBack: '欢迎回来',
    systemName: '慧清仓',
    title: '慧清仓卖家中心',
    NoMatchingData: '暂无数据',
    specificationExists: '请先选择规格项',
    ProductSpecificationIdentifier: 'SKU 为最小库存单位，用于区分不同规格（颜色 / 尺寸 / 容量等），建议填写商家内部规格编码，用于库存管理、价格设置及订单发货。',
    PleaseUploadPictures: '请上传图片',
    specificationImageRequired: '请上传规格项对应的图片',
    specificationsEmpty: '规格项不能为空',
    noPermission: '您没有权限访问',
    noIp: '未获取到IP信息',
    sureLogout: '您确认要登出系统吗？',
    forgotPass: '忘记密码',
    Expired: '已过期',
    unreadSystemNotifications: '您有未读通知，立即查看 → ',
    failedIdentityInformation: '没有获取到身份信息，请联系平台处理',
    PrivacyPolicy: '隐私政策',
    reconnect: '断线重连...',
    ByContinuing: '继续操作即表示您同意慧清仓的',
    AlreadyHaveAccount: '已有账号？请登录',
    loginAccount: '登陆账户',
    enterEmailorMobile: '输入邮箱或手机号',
    comingSoon: '功能开发中，敬请期待',
    NoData: '暂无数据',
    enter: "进入店铺",
    select: "选择您要登录的店铺",
    accountLogin: '账号登录'
  },
  home: {
    dashboardTitle: '实时业务监控 · 数据驱动决策',
    statPendingShipment: '待发货',
    statPendingReceipt: '待收货',
    statBooking: '预定中',
    statAfterSalesReview: '售后审核中',
    statSpu: 'SPU品类',
    statLowStockSku: '低库存SPU',
    statExpiring: '商品即将到期',
    statLowRating: '商品低评分数',
    orderVolumeTrendTitle: '订单量趋势',
    gmvTrendTitle: 'GMV趋势分析',
    report: '报表',
    realtimeOrder: '实时单',
    preOrder: '预订单',
    loading: '加载中...',
    reportDetailTitle: '统计明细数据',
    reportDetailSubtitle: '集中展示店铺订单量、GMV核心业务指标。',
    tabOrderTrend: '订单量交易趋势',
    tabGmvTrend: 'GMV趋势分析',
    colDate: '日期',
    colRealtimeOrder: '实时单',
    colPreOrder: '预订单',
    colRealtimeGmv: '实时单GMV',
    colPreGmv: '预订单GMV',
    query: '查询',
    exportSuccess: '导出成功',
    dateInvalid: '请选择正确的时间范围',
    backOrder: '待发货订单',
    pendingShipmentOrder: '待发货订单',
    commodityInventory: '库存低于10',
    ReservationOrder: '预订单',
    inventoryAlert: '库存预警',
    orderInformation: '订单信息',
    quantityOfGoods: '商品数目',
    remainingInventory: '剩余库存',
    settlementAmount: '历史收益',
    "newbieTask": "新手任务：发布商品",
    checkTutorial: '查看教程',
    title: '恭喜您完成新店注册。为了更好地享受HURIX的销售优势，请尽快发布您的产品。',
    "publishNow": "立即发布",
    "newlyAddedProduct": "新增商品",
    "priceDeclaration": "价格申报",
    "officialSale": "正式开售",
    "deliverToConsumers": "发货到消费者",
    "returnReview": "退货审核",
    "pendingAfterSales": "待处理售后",
    cancelOrderPending: '取消订单待处理',
    "logisticsException": "物流异常",
    "pendingViolation": "待处理违规",
    "operatingData": "运营数据",
    "realTime": "实时",
    "last7Days": "近7天",
    "last30Days": "近30天",
    moreData: '更多',
    "transactionAmount": "成交金额",
    "transactionVolume": "成交订单量",
    "numberOfCustomers": "成交人数",
    "productVisitors": "商品访客数",
    "productClicks": "商品点击数",
    "refundOrders": "退款订单",
    "storeExpenditure": "店铺支出金额",
    "withdrawAmount": "可提现金额",
    withdraw: '提现',
    yesterday: "昨日",
    flat: "持平",
    inventoryChangeTrend: "30天库存变化趋势",
    "realTimeOrderAmount": "实时单成交金额",
    "realTimeOrderVolume": "实时单成交订单量",
    "realTimeOrderCustomers": "实时单成交人数",
    "reservationOrderAmount": "预约单成交金额",
    "reservationOrderVolume": "预约单成交订单量",
    "reservationOrderCustomers": "预约单成交人数",
     colTotal: '总计',
  },
  table: {
    filter: '筛选',
    dataList: '数据列表',
    id: '编号',
    function: '功能',
    viewAddress: '查看地址',
    productImage: '商品图片',
    total: '共 x 条',
    previous: '上一页',
    next: '下一页',
    pageSize: '条/页',
    currentFilter: "当前筛选",
  },
  button: {
    continue: '继续',
    or: '或',
    save: '保存',
    create: '创建',
    saveAll: '批量保存',
    addnew: '添加',
    search: '搜索',
    reset: '重置',
    more: '更多',
    download: '下载',
    delete: '删除',
    upload: '上传',
    update: '更改',
    confirm: '确定',
    cancel: '取消',
    close: '关闭',
    submit: '提交',
    import: '导入',
    print: '打印',
    edit: '编辑',
    goEdit: '去编辑',
    clear: '清空',
    details: '详情',
    push: '推送',
    view: '查看',
    viewDetails: '查看详情',
    log: '日志',
    draftBox: '草稿箱',
    notifyConsignee: '通知收货人',
    browse: '浏览',
    Addlines: '添加行',
    Clearalllines: '清空所有的行',
    SendEmail: '发送邮件',
    sendNotification: '发送通知',
    SaveCostOnly: '保存(仅成本)',
    EmailCreditNote: '电子邮件信用证',
    ExportReport: '导出报告',
    EmailReport: '发送报告',
    Calculate: '计算',
    add: '新增',
    addGoodsReturn: 'Add For Goods Return',
    Reduce: '减少',
    batchAdd: '批量添加',
    BatchDelete: '批量删除',
    back: '返回',
    retry: '重试',
    next: '下一个',
    generateSalesReport: '生成销售报告',
    generateCustomerReport: '生成客户报告',
    addNote: '添加注释',
    hide: '隐藏',
    show: '显示',
    history: '历史',
    export: '导出',
    refresh: '刷新',
    generate: '生成',
    preview: '预览',
    select: '选择',
    PreviousStep: '上一步',
    NextStep: '下一步',
    calculate: '计算',
    bulkUpload: '批量上传',
    filter: '筛选',
    copy: '复制',
    verify: '审核',
    complete: '完成',
    AddUser: '新增用户',
    apply: '应用',
    Expand: '展开',
    Collapse: '收起',
    viewAll: '查看全部',
    modify: '修改',
    exportProductInfo: '导出商品',
    confirmAndGenerateReturnWaybill: '确定并生成面单',
  },
  permission: {
    role: '角色',
    roleName: '角色名称',
    status: '状态',
    roleType: '角色类型',
    assignmentsMenu: '分配菜单',
    enable: '启用',
    disable: '禁用',
  },
  ums: {
    userName: '账号',
    email: '邮箱',
    phone: '手机',
    password: '密码',
    resetPassword: '重置密码',
    createdTime: '创建时间',
    lastLoginTime: '最后登录时间',
    lastUpdateTime: '更新时间',
    notes: '备注',
    description: '描述',
    administratorType: '管理员类型',
    createdBy: '创建人',
    yes: 'Yes',
    no: 'No',
    addRole: '新增角色',
    editRole: '编辑角色',
    menuName: '菜单名称',
    internationalizationVariables: '国际化变量',
    menuOrder: '菜单及数',
    menuIcon: '菜单图标',
    componentName: '前端名称',
    menuLevel: '菜单层级',
    firstLevel: '一级',
    secondLevel: '二级',
    thirdLevel: '三级',
    showOrNot: '是否显示',
    sort: '排序',
    superiorMenu: '上级菜单',
    menuType: '菜单类型',
    show: '显示',
    hide: '隐藏',
    platform: '平台',
    buyer: '买家',
    seller: '卖家',
    system: '系统',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    addUser: '添加用户',
    editUser: '编辑用户',
    check: '校验',
    verificationFailed: '验证失败，请再登录一次',
    authWay: '验证',
    byEmail: '邮件',
    byPhone: '手机号',
    code: '验证码',
    usernameTaken: '该用户名已被注册',
    emailTaken: '该邮箱已被注册',
    phoneTaken: '该手机号已被注册',
    userNameLimit: '支持字母、数字和下划线，请勿使用敏感词',
    userNameLimit2: '用户名不能包含敏感词HURIX',
    userNameLimit3: '请输入6 到 20 位用户名‌',
    passwordLimit: '请使用大写字母、小写字母、数字及特殊字符中的至少三种，特殊字符包括!@#$%^&*()_+-=[]{};:,.?~`',
    passwordLimit2: '使用了不可用的特殊字符',
    newPasswordLimit3:'必须包含字母、数字、符号中至少2种',
    newPasswordLimit2:'长度为8~20个字符',
    newPasswordLimit:'不能包括空格',
    None: '无',
    isAdmin: '是否为管理员',
    setUpEmailPass: '请设置您的邮箱和密码',
    phoneRegisteredAsOperator: '此手机号已绑定操作员身份',
    newPwdTip: "8至20位新密码",
    reEnterNewPwd: "再次输入新密码",
  },
  placeholder: {
    input: '输入',
    select: '选择',
    selectWarehouse: '选择仓库',
    selectCourierBrand: '请选择承运商',
    length: '长度',
    width: '宽度',
    height: '高度',
    inputProductNameKeywords: '输入商品名称关键字',
    inputRecipient: '输入手机号或邮箱',
    inputOrderSn: '输入订单编号',
    from: "自",
    to: "至",
    minPrice: "最低价格",
    maxPrice: "最高价格",
    recipientContact: "输入收件人邮箱 / 收件人手机号",
    operatorKeyword: "输入操作员关键字",
    selectSettleCycle: '选择结算周期',
    inputOrderNumber: '输入订单编号',
    orderNoKeyword: "输入订单编号",
    productNameKeyword: "输入商品名称关键字",
    merchantSkuKeyword: "输入商家SKU关键字",
    trackingNoKeyword: "输入物流单号",
    returnNoKeyword: "输入退货编号",
    inputOrderReturnNo: "输入订单编号/退货编号",
    inputLogisticsNo: "输入退货运单号",
  },
  shop: {
    approved: '审核通过',
    unApproved: '审核未通过'
  },
  message: {
    title: '消息',
    consignmentQueryMsg: '确认删除 仓储货物 数据吗?',
    consignmentQueryMsg1: '确认删除',
    consignmentQueryMsg2: '条数据吗',
    packingTierMsg: '确认删除 包装层级 数据吗?',
    packingTierMsg1: '确认删除',
    packingTierMsg2: '条数据吗',
    locationMsg: '确认删除 位置 数据吗?',
    locationMsg1: '确认删除',
    locationMsg2: '条数据吗',
    appManagementMsg: '确认删除?',
    addedSuccessfully: '新增成功！',
    addedFailed: '新增失败',
    deleteSucceeded: '删除成功',
    deleteFailed: '删除失败',
    uploadSuccessfully: '上传成功',
    uploadFailed: '上传失败',
    copySuccessfully: '复制成功！',
    copyFailed: '复制失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    sendEmail: '邮件发送成功',
    sendFailed: '发送失败',
    exportFailed: '导出失败',
    sendCode: '验证码发送成功',
    operateSuccess: '操作成功',
    loginSuccess: '登录成功',
    operateFailed: '操作失败',
    systemError: '系统错误，请联系客服或稍后重试',
    noPermissions: '抱歉，您无权限进行此操作',
    confirmSendEmail: '你确定要发送此邮件吗？',
    recipients: '收件人:',
    duplicate: '抄送给:',
    sendEmailTip: '你确定要发送邮件吗？',
    information: '消息',
    deleteInformation: '删除后将无法恢复，确认删除吗？',
    confirmInformation: '您是否要确认提交 ?',
    modifyStatus: '是否要修改该状态 ?',
    duplicatePhoneNumber: '手机号重复',
    fileTypeMustBeJPGOrPng: '文件必须为图片',
    fileTypeMustBeJPGOrPngOrVideo: '文件必须为图片或视频',
    ratioOfImage1Is1: '图像的纵横比应该是1:1 ',
    ratioOfVideo1Is1: '视频的纵横比应该是1:1 ',
    uploadResults: '上传结果',
    warehouseNameAlreadyExists: '仓库名称已存在！',
    warehouseIsPending: '该货仓处于待审核状态，不允许重复绑定',
    unsavedChangesTips1: '您有未保存的更改，是否要保存?',
    unsavedChangesTips2: '当前步骤数据未保存，请先保存草稿？',
    areYouSure: '你确定',
    phoneRequired: '请先填写手机号',
    pleaseWait: '处理中，请稍候...',
    cannotExceedMB: '文件大小不能超过10M',
    verifyReturnAddressCorrect: '操作失败，请核实退货地址是否有误或选择其他退货承运商',
    uploadText: '点击或拖动文件到虚线框内上传',
    errorMessage1: '仅支持 xlsx 类型文件!',
    trackingNumberLengthAndDigitRule: '请输入5-50位物流单号，至少包含1个数字',
    trackingNumberCharacterRule: '仅支持字母、数字和单个连字符（-），且不能以连字符开头或结尾',
    multipleParcelsNote: '如该单号对应多个包裹，请在备注中说明',
    supportedMediaFormats: "仅支持上传图片及 m4v, mp4, mkv, mov, 3gp, webm 格式的视频",
    confirmSubmission: '确认提交',
    noticeTitle: "提示",
    goodsShippedTip: "商品已出库/发货，请再次确认审批是否通过",
    orderCancelTip: "系统将取消 HURIX 订单并自动退款，请尽快通知仓库尝试拦截快递",
    verifyCodeTip: "请输入验证码",
    phoneTip: "请输入手机号",
    emailTip: "请输入邮箱",
    deleteSkuTips: '删除此信息将永久删除所有相关变体和数据。此操作无法撤消。',
  },
  rulesTips: {
    required: '该项为必填，输入',
    requiredAndNum: '这个字段是必需的，它是数字类型。',
    noEmpty: '不能为空。',
    enterChar: '请输入3个或更多字符',
    enterChar2: '请输入2个或更多字符',
    enterSearch: '输入关键词搜索分类...',
    emailTips: '请输入有效的电子邮件地址',
    urlTips: '请输入有效的URL地址',
    addressLine1: '输入长度不能超过35个字符',
    notLessOne: '不能小于1',
    notLessZero: '不能小于0',
    enterPasswordAgain: '再次输入密码',
    passwordInconsistent: '两次输入密码不一致',
    passwordLength: '长度为 8 到 20 位字符',
    noSpace: '不能包括空格',
    passwordComplexity: '必须包含大写字母、小写字母、数字、符号中至少3种',
    twoToOneHundredAndForty: '请输入的长度限制在2到140个字符之间',
    fileSizeLess10: '文件需<10MB',
    requiredFields: '必填项不能为空',
    loginAgain: '此操作会让您强制退出 重新登陆系统',
    enterPlatformPrice: '请输入平台价格',
    enterMarketReferencePrice: '请输入市场参考价格',
    enterReferenceLink: '请输入参考链接',
    enterWeight: '请输入重量',
    postcodeTip: '邮编格式不正确，正确示例: SW1A 1AA',
    invalidData: '数据校验未通过',
    correctPhoneNumber: '请输入正确的手机号格式',
    emailNotRegistered: '该邮箱未注册',
    phoneNumberNotRegistered: '该手机号未注册',
    emailAlreadyExists: '该邮箱已存在',
    userNameExists: '该用户名已存在',
    VATNoAlready: '该VAT No.已存在',
    getCodeFirst: '先获取验证码',
    atLeastOneDocument: '请至少上传一个文件',
    QQCannotUsed: '不能使用QQ邮箱',
    maximumChar: '最多可以输入20个字符号',
    nickNameIsRequired: '昵称不能为空',
    noSpecialChars: '不允许输入特殊字符',
    onlyPDF: '仅允许上传PDF格式文件',
    onlyImageOrPDF: '仅支持上传 Image、PDF 格式文件',
    requiredCnCertificateUsername:'请输入中国国家证用户名',
    requiredUkCertificateUsername:'请输入英国国家证用户名',
    inputProductName: "请输入商品名称",
    inputProductSellingPoint: "请输入商品卖点",
    inputProductCategory: "请输入商品分类",
    inputProductWeight: "请输入商品重量",
    inputLength: "请输入长度",
    inputWidth: "请输入宽度",
    inputHeight: "请输入高度",
    inputMainImage: "请输入主图",
    specItem: "请输入规格项",
    specValue: "请输入规格值",
    hurixPrice: "请输入HURIX售价",
    marketReferencePrice: "请输入市场参考价",
    referenceLink: "请输入参考链接",
    warehouseName: "请选择仓库名称",
    merchantSku: "请输入商家SKU",
    stockNum: "请输入库存",
    expireTime: "请输入到期时间",
    supplyPrice: "请输入供货价",
    productDetail: "请输入商品详情",
    selectFreeShipping: "请选择是否包邮",
    selectSplitPackage: "请选择是否支持分箱",
    packageWeight: "请输入包裹重量",
    selectWarehouseSystem: "请选择仓库系统",
    inputAppKey: "请输入AppKey",
    inputAppSecret: "请输入AppSecret",
    selectWarehouseCode: "请选择仓库代码",
    shippingFee: "请输入运费",
    recipientName: "请输入收件人",
    selectCountry: "请选择国家",
    postcode: "请输入邮编",
    inputAddressLine1: "请输入地址行 1",
    cityTown: "请输入城市/城镇",
    cancelReason: "请输入取消原因",
    remark: "请输入备注",
    refundAmount: "请输入退款金额",
    reason: "请输入原因",
    withdrawAmount: "请输入提现金额",
    confirmNewPwdTip: "请再次输入新密码",
    operatorName: "请输入操作员姓名",
    selectRole: "请选择角色",
    accountInputTip: "请输入手机号码或电子邮件地址",
    password: "请输入密码",
    inputDetailAddress: "请输入详细地址",
  },
  product: {
    templateSteps: ['搜索分类/商品/SSIN', '选择目标商品', '自定义属性 & 价格库存', '确认添加到店铺'],
    blankForm: '空白表单',
    recommendedCategories: '推荐分类',
    importProductTemplate: '商品模板导入',
    retailInfo: '零售批发，物流配送',
    batchUpload: '批量导入商品',
    selectProductType: '选择商品类型',
    basicInfo: '基础信息',
    basicInfoTips: '填写商品的基本信息，包括名称、卖点、分类、品牌、重量、尺寸等核心属性，确保信息准确完整，有助于商品曝光和转化',
    commodityTradingInfo: '商品交易信息',
    productSpecification: '商品规格及图片',
    productDesc: '商品详情描述',
    productLogisticsInfo: '商品物流信息',
    otherInfo: '其他信息',
    shipping: '运输',
    isShippingFree: '是否包邮',
    packageWeight: '包裹重量',
    packageDimensions: '包裹尺寸',
    estimatedShippingCost: '预估运费',
    estimatedShippingCostTips: '预估运费是根据商品重量、尺寸和目的地计算的参考运费，实际运费可能会因物流商、配送方式等因素有所不同。',
    shippingNotes: '大陆地区包括英格兰、威尔士和苏格兰，偏远地区则指北爱尔兰和苏格兰高地。计算卖家类别时，我们会同时考虑取件和送件量;但送件包裹将始终按照送件费率表收费。',
    remoteAreas: '偏远地区包括以下地区',
    category: '商品分类',
    price: 'HURIX售价',
    weight: '商品重量',
    dimensions: '商品尺寸',
    quantity: '库存',
    warehouseInfo: '托管库存',
    bottomPrice: '最低价格',
    referencePrice: '市场参考价(含税)',
    referenceLink: '参考链接',
    profit: '折扣率（相对市场参考价）',
    lastCoilQuantity: '最低圈货数',
    productName: '商品名称',
    listingStatus: '上架状态',
    productStatus: '商品状态',
    productImage: '商品图片',
    skuImage: '规格图片',
    salesVolume: '销量',
    totalStock: '总库存',
    stock: '库存',
    availableStock: '可用库存',
    lockInventory: '锁定库存',
    productStock: '商品库存',
    stockLog: '库存日志',
    verifyStatus: '审核状态',
    pendingApproval: '审核中',
    reviewRejected: '审核驳回',
    selectProductCategory: '商品基本信息',
    fillInProductDetails: '商品详情',
    fillInSpec: '商品规格',
    publishedSuccessfullyMsg: '商品信息已提交',
    publishedSuccessfullyTip: '系统正在审核您的商品，请耐心等待',
    viewProductStatus: '查看商品审核状态',
    youCanAlso: '您也可以',
    goOn: '去',
    publishProduct: '发布商品',
    productReviewList: '商品审核列表',
    productPrice: '商品价格',
    sellingPoint: '商品卖点',
    productBrand: '商品品牌',
    brandName: '品牌名称',
    brandIcon: '品牌图标',
    unit: '商品单位',
    unitExplain: '产品销售单位，比如：件，盒，套',
    hostGraph: '主图',
    uploadFile: '上传文件',
    fileToWithin10MB: '请压缩文件在10M以内',
    rangeWith: '图片宽高比为 1:1,允许误差在 10% 以内',
    supportFiveFiles: '最多支持上传5个文件',
    customSpecificationItems: '自定义规格项',
    addSpecificationItems: '添加规格项',
    specificationItem: '规格项',
    specificationItemExplain: '商品的规格分类（如颜色、尺寸、材质），用于定义需要填写的规格类型',
    addSpecificationImages: '添加规格图片',
    specificationValue: '规格值',
    specificationValueExplain: '每个规格分类下的具体选项（如颜色选 “红色”、尺寸选 “M 码”），用于区分不同商品版本',
    detailedSpecifications: '规格详细',
    verifyMaterials: '审核材料',
    productInfoVerifyTip: '请提供库存证明材料、市场价凭证(第三方链接/图片等)，以确保商品信息的真实性与可用性',
    previousStep: '上一步',
    nextStep: '下一步',
    saveProduct: '发布商品',
    saveDraft: '保存草稿',
    saveTemplate: '保存模板',
    reason: '原因',
    pass: '通过',
    refuse: '拒绝',
    editInventory: '编辑库存',
    editProductInformation: '编辑货品信息',
    skuNumber: 'SKU数量',
    sellingPrice: '销售价格',
    descSelling: '当前在售，可正常下单',
    descSoldOut: '库存清零，暂不可售',
    descDelist: '已从店铺撤下，买家不可见',
    descApproved: '商品审核已通过，可上架销售',
    descPending: '商品正在审核，请耐心等待',
    descRejected: '商品未通过审核，需修改后重新提交',
    descDefault: '在这里管理你的商品',
    warehouseDescApproved: '仓库已通过审核，发布商品时可选择该仓库进行关联',
    warehouseDescPending: '仓库正在审核中，审核通过后方可用于关联商品，请耐心等待',
    warehouseDescRejected: '仓库未通过审核，请根据驳回原因修改后重新提交，审核通过后方可关联商品',
    draftDesc: '草稿不会自动提交审核，请确认商品信息无误后手动提交',
    editBrand: '编辑品牌',
    addBrand: '新增品牌',
    brandTip: '重要提示：品牌数据提交后将无法修改，请仔细核对后再进行操作。',
    reasonForRejection: '驳回原因',
    warehouseLocation: '仓库位置',
    brandInitial: '品牌首字母',
    brandLogo: '品牌Logo',
    brandZoneLargePicture: '品牌专区大图',
    brandStory: '品牌故事',
    classificationName: '分类名称',
    editCategory: '编辑分类',
    addCategory: '添加分类',
    categoryParent: '上级分类',
    classificationLevel: '分类级数',
    expirationDate: '到期时间',
    expirationDateTip: '您商品到期时间的调整，将会影响到订单，并有可能导致交易取消，您需对所有后果承担全部责任。',
    inventoryAdjustmentWarning: '若您的库存调整影响到订单并导致交易取消，您需对所有后果承担全部责任。',
    localTimeAtWarehouse: '仓库中存储产品的有效期',
    cargoOwner: '卖家名称',
    bindWarehouse: '绑定仓库',
    addAndBindWarehouse: '新增仓库',
    businessType: '业务类型',
    soldTo: '库存地',
    list: '上架',
    delist: '下架',
    less30Days: '仓库到期时间与商品发布时间之间的天数差小于30天',
    warehouseHasBeenSelected: '仓库已被选定',
    warehouseChangeTip: '【商家SPU、SKU】是否更新？',
    spu: '商家SPU',
    shipperSku: '商家SKU',
    productCommissionByThePlatform: '平台收取佣金比例',
    expired: '已到期',
    unexpired: '未到期',
    expiredStatus: '商品是否到期',
    alreadyBooked: '已被预订',
    stockTip: '请核对您的修改信息',
    pendingTips1: '该商品将于48小时内（截止至',
    pendingTips2: '）完成审核。如有疑问，请联系管理员。',
    selectedCategory: '已选：',
    selectCategory: '选择分类',
    preview: '预览',
    cumulativeEvaluation: '累计评价',
    strip: '条',
    num: '数量',
    kg: '千克',
    retailPrice: '市场零售价',
    discount: '折扣率',
    buyNow: '立即购买',
    Reservation: '我要预订',
    productTitleTem: '例如：品牌 + 型号 + 核心功能 + 适用场景\n（Apple iPhone 14 Pro 256GB 5G智能手机 深空黑色）\n（Nike Air Max 270 运动鞋 男女同款 减震透气）',
    productNameTips: '清晰准确描述商品，包含核心属性和特点，使用简洁明了的语言，不超过255个字符',
    productSellingPoint: '例如：销量/口碑 + 核心功能 + 适用场景 + 独特优势\n（全网销量2.4万+个成交，人体工学设计，久坐不累，适合游戏/办公）\n（德国进口材质，304不锈钢，终身质保，食品级安全）',
    sellingPointTips: '突出商品的核心优势和独特卖点，吸引买家注意力，促进转化，不超过500个字符',
    categoryTips: '选择正确的商品分类，有助于买家快速找到您的商品，提高曝光率和转化率',
    brandTips: '填写商品的品牌名称，确保品牌信息准确无误，有助于建立品牌形象和提高商品可信度',
    weightTips: '填写商品的实际重量，单位可以选择克(g)或千克(kg)，确保重量信息准确，避免物流问题',
    dimensionsTips: '填写商品的实际尺寸，包括长度、宽度和高度，单位为厘米(cm)，确保尺寸信息准确，避免物流问题',
    spuTips: 'SPU 为商品统一标识，建议填写商家内部商品编码，用于商品统一管理、库存追踪及多规格商品归类。',
    hostGraphTips: '宽高比：1:1。文件大小上限：10 MB。格式：JPG/PNG/GIF。尺寸：800×800px',
    specTips: '至少需要添加一个规格项，每个规格项下至少需要添加一个规格值，第一个规格项下的每个规格值必须上传对应图片，最多支持添加五个规格项。',
    fillInSpecTips: '规格项是商品的基本属性，如颜色、尺寸等，用于区分不同的SKU。<br>规格值是规格项的具体内容，如红色、蓝色、M码、L码等。',
    referenceLinkTips: '参考链接用于验证商品价格，建议填写主流电商平台的商品链接',
    warehouseNameTips: '选择商品存储的仓库，确保库存信息准确',
    detailsTips: '商品详情是向买家展示商品特点和优势的重要内容，建议详细填写',
    isReturnableTips: '设置商品是否支持退货，影响买家的购买决策',
    autoShelvesTips: '审核通过后是否自动上架商品，节省操作时间',
    isSplitTips: '是否支持将商品分多个包裹发货，适用于大件商品',
    packageWeightTips: '包裹重量是指商品包装后的总重量，影响物流费用计算',
    packageDimensionsTips: '包裹尺寸是指商品包装后的长宽高，影响物流费用计算和运输方式选择',
    selectProductTemplate: '选择商品模板',
    searchByProductOrBrand: '搜索分类 / 商品 / SSIN',
    noSku: '暂无SKU信息',
    noChange: '您未作任何修改',
    videoErr: '无法读取视频信息。 ',
    imageCropping: '图片裁剪',
    isAutoList: '审核通过即上架',
    canBeReturned: '买家退货',
    returnsAccepted: '支持退货',
    noReturns: '不支持退货',
    operationType: '操作类型',
    ownerShipmen: '卖家发货',
    resellerReturn: '分销商退货',
    ownerInventoryAdjustment: '卖家修改库存',
    expiredInventoryPurge: '仓库过期清空',
    previousStock: '修改前库存',
    nextStock: '修改后库存',
    selectMethodCreatedProduct: '请选择商品创建方式',
    unsubmittedProduct: '检测到您有未提交的商品草稿，是否',
    continueEditDraft: '继续编辑草稿?',
    selectProductTem: '添加平台已有商品',
    createNewProduct: '手动添加商品',
    noMatchProduct: '没有找到匹配的商品模板',
    enterProductName: '请输入商品名称或品牌名称',
    templateSelected: '已选择模板',
    requiredToProvideMarketPrice: '行业平均价格或同类产品在主流平台上的价格可作为卖家的定价基准。',
    requiredToProvideInventoryProofMaterials: '需商家提供库存证明材料',
    specNameExists: '规格名不能重复',
    specValueExists: '规格值不能重复',
    editStockTip: '若您的库存调整影响到订单并导致交易取消，您需对所有后果承担全部责任。',
    editProduct: '编辑商品',
    carrier: '物流商',
    transitTime: '快递时效',
    weightLimit: '重量限制',
    basicFreight: '基础运费',
    surcharge: '附加费',
    warning1: '商品处于审核中，请到对应的审核流程中查看',
    warning2: '商品处于审核驳回，请到对应的审核流程中编辑',
    WarehouseAddress: '仓库地址',
    deleteSku: '你确定删除此SKU? ',
    isSplit: '是否支持分箱≤30kg',
    splitTip: '本平台仅支持单件包裹≤30kg',
    downloadTemplate: '下载模板',
    upload: '商品导入',
    uploadNotice: '商品导入中，导入结果请关注站内信。',
    uploadReminder: '请先添加您的仓库',
    batchProductImport: '商品批量导入',
    downloadConfirm: '您确定下载该分类的模板吗',
    supplyPrice: '供货价',
    supplyPriceExplain: '全托管合同签署价',
    platformPriceExplain: '卖家建议平台售价',
    imageUploadSpecifications: '图片上传规范',
    basicRequirements: '基本要求',
    fileSize: '文件大小：单文件≤10MB（超大文件建议使用压缩工具处理）',
    aspectRatio: '宽高比例：1:1（允许 ±10% 误差，例如 800×800px 可接受 720×800 至 800×880）',
    fileCount: '上传数量：最多 5 个文件',
    formatExamples: '格式与示例',
    supportedFormats: '支持格式：JPG/PNG/GIF（建议压缩后上传）',
    sampleDimensions: '尺寸示例：800×800px（720×800、800×880 等近似比例均有效）',
    tips: '操作提示',
    tips1: '比例不符可能导致图片拉伸变形，请提前裁剪调整。',
    tips2: '超过大小限制可通过压缩工具处理文件尺寸。',
    selectCategoryTip: '请选择最细化的分类层级',
    spuExistsTip: 'SPU重复：该编号已被使用，请重新输入',
    draftId: '草稿ID',
    noOption: '无合适选项？',
    createType: '创建规格项',
    inputType: '选择规格项',
    typeEg: '示例：颜色',
    createValue: '创建规格值',
    inputValue: '输入规格值',
    valueEg: '示例：红色',
    documentProofs: '文件证明',
    customsDeclaration: '海关报关单',
    purchaseInvoice: '商品采购发票',
    warehouseEntryVoucher: '海外仓入库证明',
    certificateOfGoods: '委托仓货物证明',
    brandAuthorizationLetter: '品牌授权书',
    documentProofsTip: '卖家必须提供以上至少一项文件证明。每项最多5个文件，单文件≤10M',
    tradeLegalityDesc: '进口商品（需含商品编码、清关日期、卖家名称、税务缴纳情况等）',
    originAuthenticityDesc: '采购商品（需含VAT编号、采购方与卖家一致）',
    inventoryExistenceDesc: '第三方海外仓托管商品（需显示入库时间、SKU编码、卖家名称）',
    goodsAuthenticityDesc: '出具方仓库的官方联系方式、证明编号、货物明细',
    ipComplianceDesc: '代理/分销品牌商品（需品牌方盖章及授权有效期）',
    productHome1: '将已有商品信息批量添加到我的店铺',
    productHome2: '点击按钮-下载模版-填写信息-上传文件-一键批量添加',
    productHome3: '快速添加平台现有商品到我的店铺',
    productHome4: '点击搜索商品-选择商品-自定义属性-确认添加',
    productHome5: '创建全新商品到我的店铺',
    productHome6: '点击手动创建-完善商品信息-自定义设置-确认创建',
    productHome7: '为了更好地享受 HURIX 的销售优惠，请尽快发布您的产品。',
    productHome8: '同步已授权店铺商品到HURIX',
    productHome9: '从已授权的三方店铺同步商品信息到HURIX',
    noProducts: '暂无相关商品',
    createANewProduct: '创建一个新商品',
    authorizedStore: '授权店铺',
    rulesCenter: '规则中心',
    priceAndStock: '价格和库存',
    uploaded: '已上传',
    introTip: '支持拖拽，单张图片建议宽度620-1290px，高度<2000px，超出尺寸平台将自动裁剪以保证展示效果，≤5MB，仅支持jpg/jpeg/png格式',
    linkOtherWarehouse: '新增其他仓库',
    noWarehouseFound: '暂无可用仓库？',
    selling: '售卖中',
    soldOut: '已售罄',
    searchPlaceholder: '输入商品名称 / SSIN / 商家SPU / 商家SKU，多条可用逗号隔开',
    searchPlaceholderDraft: '输入商品名称 / 草稿ID / 商家SPU，多条可用逗号隔开',
    publishSimilar: '发布相似商品',
    priceMustBeLower: '售价与VAT之和必须低于参考价',
    applyForEntry: '申请入驻',
    importRecords: '导入记录',
    fileName: '文件名称',
    uploadTime: '上传时间',
    uploading: '解析中',
    parsingSuccessful: '解析成功',
    parsingFailed: '解析失败',
    viewTaskList: '查看任务列表',
    confirmDeleteDraft: '确认删除草稿',
    sureToDeleteDraft: '您确定要删除草稿吗？草稿删除后将无法恢复。',
    confirmPutOnSale: '确认上架商品',
    confirmTakeOffline: '确认下架商品',
    takeOfflineTip: '商品下架后将不再参与售卖。',
    publishSimilarTip: '发布相似品请注意不要创建同样的商品，避免由于多个同款同时销售导致消费者购物体验差、销量损失等问题。',
    profitable: '利润',
    imageNotFound: '未找到图片元素',
    invalidCropArea: '请选择有效的裁剪区域',
    abnormalImageSize: '图片尺寸异常',
    cropAreaOutOfBounds: '裁剪区域不在图片范围内',
    browserNotSupported: '浏览器不支持裁剪功能',
    imageSizeExceeded: '图片压缩后仍超过10M，请尝试更小的裁剪区域',
    products: '件商品',
    TotalProductPrice: '商品总价',
    taxes: '税费',
    total: '总计',
    productVat: "商品增值税",
    shippingVat: "运费增值税",
  },
  order: {
    MyOrder: '管理订单',
    order: '订单',
    orderNumber: '订单编号',
    buyer: '买家名称',
    orderTime: '下单时间',
    orderStatus: '订单状态',
    startDate: '开始日期',
    endDate: '结束日期',
    orderAmount: '订单金额',
    paymentMethod: '支付方式',
    viewOrder: '查看订单',
    PendingPayment: '待支付',
    toBeConfirmed: '待确认',
    pendingShipment: '待发货',
    partialShipment: '部分发货',
    inTransit: '运输中',
    completed: '已完成',
    closed: '订单关闭',
    OrderCompleted: '已完成',
    OrderClosed: '已关闭',
    Cancelled: '已取消',
    alipay: '支付宝',
    wechat: '微信',
    unpaid: '未支付',
    BuyerPlacesOrder: '买家下单',
    PaymentSuccessful: '付款成功',
    MerchantShipsGoods: '商家发货',
    TransactionCompleted: '交易完成',
    modifyRecipientInformation: '修改收货人信息',
    orderLog: '订单日志',
    separatePackageDelivery: '分包裹发货',
    ShipOrder: '发货',
    noUnshippedItems: '不存在未发货的商品，请检查订单',
    orderStatusTip: "订单状态已改变，请刷新浏览器",
    cancellationOfOrder: '取消订单',
    addANote: '添加备注',
    logisticsInformation: '物流信息',
    InsuranceInformation: '保险信息',
    LogisticsUpdates: '物流动态',
    orderDetails: '订单详情',
    receiptInformation: '配送至',
    buyerMessage: '买家留言',
    orderNotes: '订单备注',
    invoiceInformation: '发票信息',
    noInvoiceInformation: '未提供发票信息',
    specifications: '规格',
    number: '数量',
    subtotal: '小计',
    totalAmount: '商品总价',
    payableAmount: '应付金额',
    FullName: '收件人',
    recipientRegion: '收件地区',
    detailedAddress: '详细地址',
    shippingAddress: '收货地址',
    ShippingInformation: '收货信息',
    DeliveryInformation: '配送信息',
    DeliveryMethod: '配送方式',
    LogisticsDelivery: '物流配送',
    OtherInformation: '其它信息',
    PurchaseSource: '购买来源',
    WebVersion: '网页版',
    postcode: '邮编',
    orderType: '订单类型',
    realtimeOrder: '实时单',
    purchaseRequest: "购买请求",
    shipmentQuantity: "发货数量",
    deliveryTime: "发货时间",
    noLogisticsInformation: "暂无物流数据",
    trackingNumber: "发货单号",
    logisticsCompany: "承运商",
    logisticsStatus: "物流状态",
    platformHandlingFee: "平台服务费",
    settlementHandlingFee: '结算手续费',
    CardPaymentHandlingFee: '支付手续费',
    refundFee: '退款手续费',
    refundFeeRule: '若发生退款，每笔将收取固定手续费num',
    revenueAmount: "收入金额",
    ReservationInformation: "预订信息",
    ReservationPeriod: "预订周期",
    priceModel: "价格模式",
    NumberOfReservations: "预订数量",
    dividedParcelDelivery: "分包裹发快递",
    LogisticsTrackingNumber: "物流单号",
    unitPrice: '单价',
    ParcelSent: '已发包裹',
    SurplusCommodity: '剩余商品数量',
    subtotalOf: "小计",
    selectLogisticsCompany: "请选择承运商",
    fillTrackingNumber: '请填写物流单号',
    fillLogisticsTime: '请填写发货时间',
    selectItemShip: '请至少选择一件商品发货',
    PleaseShipAtLeastOneItem: '请至少发货一件商品',
    whetherModifyReceivingInformation: '是否要修改收货信息',
    sureWantCancelOrder: '确定取消此订单？',
    WantChangeRemarksOrder: '您确定要修改备注订单?',
    RealTimeOrder: '实时单',
    ReservationOrder: '预订单',
    lockPriceModel: '锁价模式',
    noLockPriceModel: '不锁价模式',
    days: '天',
    PromiseShip: '请在',
    PromiseShip2: '内确认发货',
    autoCancelTip: "", // 有用别删
    autoCancelTip2: "后自动取消订单，请及时发货",
    ReservationInProgress: '预订中',
    PreOrderInProgress: '预订中',
    proportionOfDeposit: '订金比例',
    amountOfDeduction: '抵扣金额',
    deposit: '订金',
    AwaitingReceipt: '待收货',
    waitBuyerShip: "待买家发货",
    waitSellerReceive: "待卖家收货",
    ReservationCompleted: '预订完成',
    PreOrderCompleted: '预订完成',
    batchShipment: '批量发货',
    RemainingReservableQuantity: '剩余预订数量',
    ReservationOrderNo: '预订单编号',
    PolicyNumber: '保险单号',
    InsuranceCompany: '保险公司',
    PolicyStatus: '保单状态',
    AmountInsurance: '保险费金额',
    AmountCompensation: '赔付金额',
    InEffect: '生效中',
    failure: '失效',
    undo: '撤销',
    ClaimsProgress: '理赔中',
    CompensationComplete: '已赔偿',
    Terminate: '终止',
    Frozen: '冻结',
    state: '州/省',
    downloadBatchShippingTemplate: '下载批量发货模板',
    batchShippingTemplate: '批量发货模板',
    noOrder: '您没有需要发货的订单!',
    country: '国家/地区',
    city: '城市/城镇',
    enterCorrectEmail: '请输入正确的邮箱地址',
    InRefund: '退款中',
    RefundSuspension: '退款挂起',
    RefundSuccessful: '退款成功',
    RefundFailure: '退款失败',
    InRefundLog: '您的商品正在退款中，请耐心等待',
    RefundSuspensionLog: '账户余额不足，退款被挂起',
    RefundCompletedLog: '您的商品退款成功',
    RefundFailureLog: '您的商品退款失败',
    insufficientStockReservation: '商品库存不足，预订取消并退款',
    refund: '退款',
    created: '已创建',
    enterReasonRefund: '请输入退款原因',
    createdLog: '订单已创建',
    toBeConfirmedLog: '您的订单已成功提交，我们正在为您处理订单，请稍后',
    PendingPaymentLog: '订单已确认，等待买家付款',
    pendingShipmentLog: '买家已付款，快发货吧！',
    partialShipmentLog: '部分商品已经发货，不要忘了发出剩下的商品哦！',
    InTransitLog: '商品已全部发货，正在运输中',
    WaitToBeReceivedLog: '商品到达目的地，等待买家收货',
    completedLog: '订单已完成，感谢您的配合',
    ReservationInProgressLog: '预订中(等待履约)',
    ReservationCompletedLog: '所有预订商品已购买，预订单结束',
    closedLog: '支付超时,系统取消订单',
    CancelledLog: '该订单已被取消',
    RefundLog: '退款日志',
    RefundAmount: '退款金额',
    RefundStatus: '退款状态',
    BuyerPaid: '买家已付',
    PlatformCommission: '平台佣金',
    PaidInAmount: '实收金额',
    commodityInformation: '商品信息',
    NumberOfPurchaseRequests: '发起购买请求数',
    InitiatePurchase: '发起购买',
    cancelPurchase: '取消购买',
    CommodityQuantity: '商品数量',
    completeTime: '完单时间',
    level: '等级',
    returnReview: '退货退款待处理',
    returnInfo: '退货信息',
    auditOperation: '审核操作',
    returnAndRefunds: '退货/退款',
    fillDeliveryAddress: '填写收货地址',
    fillInReturnAddress: '填写退货地址',
    defaultReturnWarehouseAddress: '默认地址为商品所在的仓库地址',
    pleaseFillDeliveryAddress: '请填写收货地址',
    returnAddress: '退货地址',
    ReturnRequestNo: '退货请求 #',
    ReturnLog: '退货日志',
    createdReturn: '收到新的退货申请',
    toBeConfirmedReturn: '请及时处理退货申请',
    pendingShipmentReturn: '退货已审核通过，等待买家发货',
    inTransitReturn: '退货商品已发出，运输中',
    AwaitingReceiptReturn: '退货商品已到达，请尽快取件',
    completedReturn: '退货流程完成，进入退款阶段',
    reviewRejectedReturn: '卖家拒绝申请，退货流程终止',
    CancelledReturn: '退货申请已取消，退货流程关闭',
    confirmReceipt: '确认收货',
    confirmReceivedGoods: '请确认您已收到货',
    returnList: '退货列表',
    returnInformation: '退货信息',
    returnStatus: '退货状态',
    returnTime: '退货时间',
    pendingReturnsReview: '您有未审核的退货申请',
    platformInterventionInProgress: '平台介入中',
    returnReason: '退货原因',
    returnVerificationPhotos: '退货验证照片',
    Returned: '发生退货',
    returnDetails: '退货详情',
    breachQuantity: '违约数量',
    purchasableQuantity: '可购买数量',
    refundDetails: '退款明细',
    refundReason: '退款原因',
    refundTransaction: '退款流水号',
    RefundsReturns: '退货与退款',
    returnOccurs: '退货',
    refundHappens: '退款',
    None: '暂无',
    purchasableQuantityReduce: '商品库存不足，可购买数量减少refundQuantity',
    releaseQuantityRefunded: '商品库存不足导致退款',
    returnRecords: '退货记录',
    refundRecords: '退款记录',
    ReturnId: '退货编号',
    credential: '凭证',
    afterConfirmingReceipt: '确认收货后，相应的款项将退还给买家。',
    negotiationHistory: '协商历史',
    ReturnRequestSubmitted: '发起了退货申请,等待卖家处理',
    ReturnRequestApproved: '退货申请审核通过',
    buyerHasShipped: '买家已发货',
    ReceiptConfirmedSeller: '卖家已确认收货',
    ReturnRequestRejected: '退货审核被驳回',
    ReturnRequestCancelled: '取消了退货申请',
    notes: '备注',
    RefundType: '退款类型',
    RequestPlatformIntervention: '申请平台介入',
    PlatformIntervention: '平台介入',
    PlatformProcessing: '平台处理中',
    PlatformAdjustsReturnStatus: '平台调整退货状态',
    credentialIsBasis: '凭证是平台处理纠纷时的重要依据',
    senderAddress: '发货人地址',
    importantNoticeStrictlyShip: '重要提示：请严格按买家指定的物流商发货。不同商品选择的物流商可能不同，请仔细核对后发货。',
    selectedShippingCarrier: '此订单选择的承运商：',
    SuccessfullyDeleted: '删除成功',
    CreditCard: '信用卡',
    Review: '审核',
    CancellationTime: '取消时间',
    CancellationReason: '取消原因',
    OrderCancellationDetails: '取消订单详情',
    CancellationLog: '取消订单日志',
    RequestTime: '申请时间',
    cancelHasBeenInitiated: '发起了取消订单申请',
    ReviewStatus: '审核状态',
    pendingApproval: '待审核',
    pendingSubmission: '待提交',
    pleaseReviewCancel: '买家发起了取消订单申请',
    PendingCancellationReview: '您有待审核的取消订单申请',
    cancelAuditReminder: '您有未审核的取消订单申请',
    RefundOnly: '仅退款',
    PartyLiableShipment: '发货运费承担方',
    PartyLiableReturn: '退货运费承担方',
    shipmentTotalMoney: '发货运费总额',
    returnTotalMoney: '退货运费总额',
    TotalRefundAmount: '退款总额',
    estimated: '预估',
    ReturnLogisticsCompany: '退货承运商',
    all: '全部',
    AllOrders: '全部订单',
    requiredToShip: '24h需发货',
    OvertimeShipped: '超时未发货',
    ExportOrder: '导出订单',
    LastDay: '最近一天',
    LastDay7: '最近一周',
    LastDay30: '最近一个月',
    LastDay90: '最近三个月',
    AfterSalesStatus: '售后状态',
    Balance: '余额',
    BuyerInformation: '买家信息',
    BuyerRemarks: '买家备注',
    BuyerNickname: '买家昵称',
    price: '价格',
    paymentTime: '付款时间',
    OrderTotal: '订单总计',
    orderTotalSubVat: '不含税订单金额',
    ReservationDeductionAmount: '预订抵扣',
    ShipFree: '包邮',
    returnLabelGenerationSellerNote: '当前退货审核通过后，系统自动生成快递面单，该过程可能失败，失败后请重新审核',
    labelGenerationStatus: '快递面单状态',
    labelGeneratedSuccess: '生成成功',
    labelGenerating: '生成中',
    labelGeneratedFailed: '生成失败',
    GeneratingLabel: '退货面单生成中',
    returnShippingLabelGenerating: '退货快递面单生成中',
    consigneeEmailOrPhone: '收货人手机号/邮箱',
    afterSaleRecordsTip: 'num条售后记录，点击查看',
    hours: '小时',
    minutes: '分钟',
    orderCreatedTime: '订单创建时间',
    platformSelfOperated: "平台自营",
    refundOnlyTip: "仅退款支持调整退款金额，建议您仔细核对后修改，减少不必要的纠纷",
  },
  logistics: {
    shippingCost: '运费',
    deliveryType: '配送类型',
    standardSingleParcel: '‌普运单包',
    expressSingleParcel: '速运单包',
    multipleParcels: '多包裹',
    weightLimit: '‌重量限制',
    perParcel: '单个包裹',
    transitTime: '‌时效',
    businessDays: '工作日',
    BaseShippingCost: '‌基础运费',
    Surcharge: '附加费',
    SeparateRates: '独立计费',
    remoteAreas: '偏远地区 +',
    remoteArea: '偏远地区',
    MultiParcelFee: '多包裹费用',
    chargeableWeight: '计费重量‌',
    AddressLine1: '‌地址行 1（或公司名称）',
    AddressLine2: '‌地址行2',
    AddressLine: '‌地址行1',
    Recipient: '收货人',
    addAddress: '添加地址',
    SureDeleteShippingAddress: '你确定删除这个收货地址吗？',
    shippingBillingRules: '运费计费规则',
    remoteAreaNoFreeShipping: '偏远地区不包邮',
    billingWeightComparisonTable: '计费重量对照表',
    billingWeightComparisonTableRemoteArea: '计费重量对照表（偏远地区）',
    isRemoteArea: '是否偏远地区？',
    yesOption: '是',
    noOption: '否',
    UKMainland: '英国本土',
    modifyLogisticsInfo: '修改物流信息',
    fillInModifiedInfo: '请填写修改信息',
    UnitedKingdom: '英国',
    yodelServiceCentreAndLocalAreas: 'Yodel服务中心及当地地区',
    postcodeDistrict: '邮政编码区域',
    standardRate: "标准费率",
    ladderBilling: "阶梯计费",
    currentBilling: "本次计费",
    estimatedDeliveryText: "预计3-7个工作日送达",
    earliestShipTip: "预计最早于24点之前发货",
  },
  settings: {
    manualShipment: '手动发货或通过Excel批量发货',
    autoPushOrder: '订单将自动推送至该系统',
    primaryClassification: '一级分类',
    addSubcategory: '添加子分类',
    expand: '展开分类',
    collapse: '收起分类',
    parameter: '参数',
    optionalValues: '选项值',
    parameterGroup: '参数组',
    noParameter: '暂无参数绑定信息',
    warehouseCode: '仓库编码',
    warehouseName: '仓库名称',
    enterWarehouseName: '请输入货物所在仓库的名称',
    warehouse: '仓库',
    address: '地址',
    countryCode: '国家/地区',
    email: '邮箱',
    addWarehouse: '新增仓库',
    pleaseContactCustomer: '请联系客服',
    editWarehouse: '编辑仓库',
    warehouseLoading: '仓库加载中...',
    warehouseEmail: '联系邮箱',
    warehouseSystem: '仓库系统',
    clickToViewAppKeyAndAppSecret: '点击查看如何获取AppKey和AppSecret',
    pleaseEnterAppKey: '请输入AppKey',
    pleaseEnterAppSecret: '请输入AppSecret',
    warehouseCodeLabel: '仓库代码',
    needToFillAppKeyAndAppSecretFirst: '需先填写AppKey和AppSecret',
    postCode: '邮编',
    deliveryInfo: '配送设置',
    weightRange: '重量范围',
    britishMainland: '英国本土',
    newRule: '新增规则',
    andAbove: '及以上',
    cost: '运费（不含增值税）',
    minWeight: '最小重量',
    oneRuleRequired: '至少需要保留一条规则',
    abovePreviousMaximum: '需大于上一区间上限 ',
    consigneeName: '收/发货人名',
    consigneeSurname: '收/发货人姓',
    consigneeEmail: '收/发货人邮箱',
    consigneeInformation: '收/发货人信息',
    updateConsignee: '仓库设置'
  },
  menu: {
    myShelves: '我的货架',
    dashboard: '仪表盘',
    brandAudit: '品牌审核',
    addProduct: '新增商品',
    editProduct: '修改商品',
    permission: '权限',
    warehouseList: '仓库列表',
    userList: '操作员列表',
    roleList: '角色列表',
    product: '商品',
    productTemplate: '草稿箱',
    productRelease: '商品发布',
    productList: '商品列表',
    productDetails: '商品详情',
    platformProducts: '平台商品',
    platformVerify: '平台审核',
    productSort: '商品分类',
    brandManagement: '品牌',
    addBrand: '添加品牌',
    editBrand: '编辑品牌',
    unitOfMeasurement: '计量单位',
    platformRole: '平台角色',
    menuList: '菜单列表',
    resourceList: '资源列表',
    platformUsers: '平台用户',
    mallUsers: '商城用户',
    shop: '货架',
    operator: '账号',
    myShop: '我的货架',
    order: '订单',
    myOrder: '管理订单',
    platformOrders: '平台订单',
    orderList: '订单列表',
    settings: '设置',
    warehouseAudit: '仓库审核',
    myWarehouse: '我的仓库',
    myProducts: '我的商品',
    ShippingList: '发货列表',
    returnApplicationProcessing: '退货申请处理',
    returnReasonSetting: '退货原因设置',
    ReturnReasonDetails: '退货原因详情',
    Marketing: '营销',
    SecondKillActivityList: '秒杀活动列表',
    SecondsKillTimeList: '秒杀时间段列表',
    SecondsKillTimeSelection: '秒杀时间段选择',
    SeckillProductList: '秒杀商品列表',
    CouponList: '优惠券列表',
    AddCoupons: '添加优惠券',
    ModifyCoupon: '修改优惠券',
    CouponCollectionDetails: '优惠券领取详情',
    BrandRecommendation: '品牌推荐',
    NewProductRecommendation: '新品推荐',
    PopularRecommendation: '人气推荐',
    SpecialTopicRecommendation: '专题推荐',
    AdvertisingList: '广告列表',
    AddAds: '添加广告',
    EditorialAdvertising: '编辑广告',
    orderAuditList: '管理退货',
    settlementList: '结算列表',
    settleDetails: '结算详情',
    AfterSalesDetails: '售后详情',
    AfterSalesService: '售后服务',
    fund: '资金',
    accountCenter: '账户中心',
    billManagement: '我的账单',
    finance: '财务',
  },
  tableColumns: {
    operator: '操作人',
    time: '时间',
    previousStatus: '变更前状态',
    currentState: '当前状态',
    creditValueBeforeChange: '变更前信用值',
    currentCreditValue: '当前信用值',
  },
  im: {
    searchForContacts: '搜索联系人',
    ChatLog: '对话记录',
    send: '发送',
    wouldLikeTalk: '您想聊点什么...',
    noMore: '没有更多了',
    imageFormat: '图片格式不符合要求,仅支持jpg、jpeg、png类型',
    withdraw: '撤回',
    ShelfMessage: '消息',
    PlatformAdministrator: '平台管理员',
    allMessages: '全部消息',
    productReviewRejected: '商品审核驳回',
    productReviewApproved: '商品审核通过‌',
    productExpirationReminder: '商品到期提醒‌',
    customerService: '客服',
    reachedHurixCustomer: '您好，这里是慧清仓客服部，很高兴为您服务。',
    frequentlyAskedQuestions: '常见问题',
    refundReturnPolicy: '退货退款政策',
    messageNotifications: '通知',
    noNotifications: '暂无通知',
    connectionStatus: '连接已断开',
    csConnectionError: '您与客服的连接已中断，请尝试重新连接或选择其他联系方式',
    reconnectAction: '重新连接',
    alternativeContactMethod: '其它联系方式',
    ScanQRcodeTip: '关注微信服务号进行在线咨询',
  },
  shelves: {
    shelfInformation: '货架信息',
    shelfLogo: 'Logo',
    shelfDescription: '货架描述',
    companyInformation: '公司信息',
    companyName: '公司名称',
    contacts: '联系人',
    registrationNo: '公司注册号',
    assigningRoles: '分配角色',
    pleaseSelectARole: '请选择角色',
    RegistrationNotice: '入驻须知',
    registrationRequirementsNotice: '请确保您充分知悉并符合以下基本入驻条件及说明，逐条确认后即可申请：',
    authenticityInformation: '提交的信息和证明文件的真实性。',
    ProductsComplyStandards: '符合国家质量标准，不侵犯他人知识产权。',
    additionalInformationOrDocumentation: '慧清仓有权对商户信息和证明文件进行抽查，以核实其真实性、合法性。',
    hadReadService: '我已阅读并同意',
    serviceTerms: 'HURIX货主自营服务协议',
    successfullySettledIn: '您的申请已提交，请耐心等待。',
    sendEmailResult: '我们将通过电子邮件通知您结果。',
    CompanyName: '公司名称',
    RegistrationNo: '注册编号',
    Contact: '联系人',
    fillFirstName: '请输入联系人名',
    fillLastName: '请输入联系人姓',
    EmailVerificationCode: '邮箱验证码',
    successfulSubmission: '提交成功',
    EmailIncorrect: '邮箱验证码错误，请重新获取后输入',
    SMSIncorrect: '手机验证码错误，请重新获取后输入',
    NoAccountRegister: '还没有账号？点击立即注册',
  },
  noPage: {
    pageLost: '很抱歉，页面它不小心迷路了',
    checkPage: '请检查您输入的网址是否正确，请点击以下按钮返回主页或者发送错误报告 ',
    goHome: '返回首页'
  },
  logOff: {
    title: '注销账号',
    warning: '重要提示',
    warningTips: '账号注销是一项不可逆的操作，一旦提交申请，账号及所有相关数据将被永久删除。请在继续操作前确认以下事项：',
    allProductDelist: '请确保店铺内所有商品已下架',
    ensureOrderComplete: '请确保所有订单已处理完毕',
    allDataDelete: '店铺所有数据将被永久删除',
    allInfoDelete: '店铺关联的所有信息将无法恢复',
    verifyEmail: '验证邮箱',
    enterEmail: '请输入注册邮箱',
    confirmCancel: '确认注销',
    cancelAccountCancellation: '取消注销',
    cancelStatus: '注销状态',
    successTitle: '账号注销成功',
    verificationSent: '验证码已发送至您的邮箱',
    stepMessages1: '正在校验邮箱信息...',
    stepMessages2: '正在检查商品下架状态...',
    stepMessages3: '正在校验订单状态...',
    stepMessages4: '正在校验账单信息...',
    stepMessages5: '正在校验欠款情况...',
    stepMessages6: '正在校验钱包余额...',
    stepMessages7: '请确认注销账号...',
    confirmCancellation: '确认注销',
    successMessages1: '邮箱校验完成',
    successMessages2: '商品下架检查通过',
    successMessages3: '订单状态检查通过',
    successMessages4: '账单结算检查通过',
    successMessages5: '欠款检查通过',
    successMessages6: '钱包余额检查通过',
    successMessages7: '账号已成功注销',
    passwordPlaceholder: '请输入您的账号密码',
    progressTitle: '账号注销中...',
    steps1: '验证信息',
    steps2: '下架商品',
    steps3: '检查订单',
    steps4: '检查待结算订单',
    steps5: '检查欠款',
    steps6: '检查钱包余额',
    steps7: '密码确认',
    cancelConfirm: '确定要取消注销流程吗',
    emailVerityFailed: '邮箱验证码校验失败',
    productsNotDown: '商品下架检查未通过，请先下架所有商品',
    pendingOrderError: '订单状态检查未通过，请先处理所有未完成订单',

    autoTakeDown: '立即下架',
    manualTakeDown: '手动下架',
    allProductsDown: '所有商品已成功下架',
    goProcessOrders: '去处理订单',
    goSettleOrders: '去查看账单',
    goRepayDebt: '立即还款',
    goWithdraw: '去提现',
    unsettledOrderError: '账单结算检查未通过，请等待所有订单完成结算',
    debtError: '账户存在待还欠款，暂无法操作，请先结清全部欠款',
    walletBalanceError: '钱包余额检查未通过，请先提现所有余额',

    cancelFailed: '注销失败',
    checkUnsettledOrdersFailed: '检查待结算订单失败',
    checkDebtFailed: '检查欠款失败',
    checkWalletBalanceFailed: '检查钱包余额失败',
    consequence1: '店铺内所有商品将被下架',
    consequence2: '店铺内所有订单将失效',
    consequence3: '店铺内所有账单将失效',
    consequence4: '店铺所有数据将被永久删除',
    consequence5: '店铺关联的所有信息将无法恢复',
  },
  register: {
    TwoStepVerification: 'MFA 多因素认证',
    AddValidatorApplication: '添加验证器应用',
    Validator: '验证器',
    authenticatorApp: '认证器应用程序',
    generatePasswordsConnection: '使用应用程序生成一次性密码，无需连接网络。',
    enterGeneratedPassword: '您将在登录时输入所产生的一次性密码，方式与使用短信接收一次性密码相同。',
    OpenYourAuthenticatorApp: '打开您的认证器应用程序。',
    NeedAuthenticatorApp: '需要认证器应用程序?',
    AddAccountScanQR: '在应用程序中添加帐户，然后扫描下面的二维码。',
    enterThePassword: '输入一次性密码。',
    qrCodeConfirmGuide: '扫描二维码后，点击下方的确定按钮。',
    AfterScanningQR: '扫描二维码后，输入应用程序生成的一次性密码:',
    VerifyAndContinue: '验证一次性密码并继续',
    IncorrectPassword: '密码错误，若重复出现此错误，请重新扫描二维码',
    DownloadAuthenticatorApp: '下载认证器应用程序',
    HowToDownload: '如何下载：',
    yourAppStore: '前往手机的应用商店。',
    SearchAuthenticatorApp: '搜索“认证器应用程序”。',
    DownloadApp: '下载应用程序。',
    GoogleAuthenticator: '例如：AWS Virtual MFA、Google 身份验证器、Microsoft Authenticator',
    hasBeenAddedSuccessfully: '验证器应用添加成功',
    ValidatorApp: '验证器应用',
    whetherDeleteAuthenticator: '是否确认删除该验证器',
    enterPasswordReceivedNumber: '请输入尾号为【phoneNum】的电话号码收到的一次性密码：',
    enterAuthenticatorGenerated: '请输入身份验证器应用生成的一次性密码：',
    verificationFailed: '验证码校验失败，请重新获取再输入',
    authenticatorBeforeUsing: '请前往【账户中心】>【两步验证】添加验证器应用后使用',
    identityWithEmail: '为保护账户安全，请使用邮箱【emailNum】验证身份',
    identityInputEmail: '请使用邮箱【emailNum】验证身份',
    NoEmailFound: '没有获取到用户邮箱',
    Attachment: '附件',
    receivedAtEmail: '请输入【emailNum】收到的一次性密码',
    UseAnotherAuthenticator: '使用其它验证器',
    selectObtainVerification: '请选择获取验证码的方式',
    enterPasswordGenerated: '请输入【AuthenticatorName】生成的一次性密码',
    AuthenticatorAppName: '验证器应用名称',
    enterAuthenticatorAppName: '请输入您的验证器应用名称',
    SetDefault: '设为默认',
    DefaultAuthenticator: '默认验证器',
    ConfirmSettingDefault: '确认设为默认验证器吗？',
    PleaseSetAnother: '请先将其它验证器设置为默认验证器',
    RegisterAsSeller: '注册成为卖家',
    ShipperInformation: '卖家信息',
    username: '用户名',
    nickName: '昵称',
    phoneNumber: '手机号',
    phoneVerificationCode: '手机验证码',
    phoneNumberRegistered: '该手机已注册',
    IdentityVerification: '身份验证',
    selectIdentityVerification: '请选择身份验证的方式',
    enterNewMobile: '请输入新的手机',
    enterNewEmail: '请输入新的邮箱',
    UpdatePhoneNumber: '修改手机号',
    UpdateEmail: '修改邮箱',
    samePhoneNumber: '新手机号与当前绑定号码相同，请使用其它手机号',
    sameEmail: '新邮箱与当前绑定邮箱一致，请使用其他邮箱',
    validatorAppLimitTip: '系统仅支持添加一个验证器应用，您可以先删除已添加的应用，再添加新的验证器应用',
    firstName: '名字',
    lastName: '姓氏',
    Privacy: '隐私',
    Clause: '条款',
    PoweredBy: '由',
    PoweredBy2: '提供支持',  // 不要删
  },
  settlement: {
    ReservationOrderNo: '预订单编号',
    payAmount: '应付金额',
    deductionType: '抵扣类型',
    status: '结算状态',
    time: '结算时间',
    settlement: '结算',
    pendingSettlement: '待结算',
    delayedSettlement: '延期结算',
    isDelay: '是否延期',
    normal: '正常',
    settled: '已结算',
    payAmountDue: '结算欠款明细',
    settlementFailed: '结算失败',
    confirm: '您确认对当前订单进行结算吗？',
    tradingTime: '交易时间',
    platformTransactionId: '平台交易流水号',
    reconciliation: '对账',
    reconciliationStatus: '对账状态',
    myMoneyTransactionId: 'MyMoney交易流水号',
    transactionAmount: '平台交易金额(£)',
    myMoneyFee: 'MyMoney手续费(£)',
    myMoneyTax: 'MyMoney税费(£)',
    platformReceivedAmount: '平台入账金额(£)',
    transactionType: '交易类型',
    reconciliationResult: '对账结果',
    discrepancyType: '差异类型',
    reconciliationTime: '对账时间',
    adjustmentAmount: '平账调整金额(£)',
    adjustmentRemark: '平账备注',
    estimatedAdjustment: '预平账',
    uploadReconciliationFile: '请上传对账文件',
    unreconciled: '未对账',
    reconciling: '对账中',
    completed: '对账完成',
    balanced: '平账',
    imbalanced: '失衡',
    overage: '长款',
    shortage: '短款',
    amountMismatch: '金额不符',
    platformAdvanceLogisticsFee: '退货运费(£)',
    shippingCostCompensation: '销售运费补偿(£)',
    ownerSettlementAmount: '预计结算金额(£)',
    settlementAmount: '结算金额(£)',
    actualOrderAmount: '订单实际金额(£)',
    paymentAmount: '支付金额(£)',
    orderTransactionRecord: '订单流水',
    settlementHandlingFee: '结算手续费',
    salesShippingTrackingNumber: '销售物流单号',
    expectedSettlementTime: '预计结算时间',
    unsettledReason: '未结算原因',
    shippingFee: '销售运费(£)',
    returnShippingTrackingNumber: '退货物流单号',
    totalProductPrice: '商品总价(£)',
    cardPaymentRefundFee: '卡支付退款手续费(£)',
    returnLossFee: '退货损耗费(£/包裹)',
    packagingLaborFee: '包装&人工费(£/包裹)',
    deductionAmount: '扣款金额',
    pendingSettleDesc: '结算周期内，已完成且无退货风险的待结算订单（已过14天退货保障期）',
    settledDesc: '结算周期内，已完成且无退货风险的已结算订单（已过14天退货保障期）',
    settleCycle: '结算周期'
  },
  terms: {
    conditions: '条款与条件',
    privacy: '隐私政策',
    storeOpeningNotice: '商家开店须知',
    haveRead: '我已阅读并同意',
    noReadTip: '请先阅读并勾选同意协议，才能完成注册哦~ ',
    and: '和',
    sellerCodeOfConduct: '卖家行为规范',
  },
  afterSale: {
    sellerReviewDeadlinePrompt: '卖家需在',
    noAction: '内完成审核，超时未处理自动审核通过',
    timedOutStatus: '00:00:00',
    BuyerAppliesReturn: '买家申请退货',
    InProcessing: '处理中',
    ReviewCompleted: '审核完成',
    ReturnProcessing: '退货处理中',
    BuyerInitiatesReturn: '买家发起退货申请',
    AfterSalesInformation: '售后信息',
    RefundAfterReceiptProducts: '已收货退款',
    ProductsReceived: '已收到货',
    ProductsNotReceived: '未收到货',
    AfterSalesNo: '售后编号',
    ApplicationAmount: '申请金额',
    BuyerEntitledRefund: '买家应收退款',
    AfterSalesReason: '售后原因',
    AfterSalesType: '售后类型',
    ReceiptStatus: '收货状态',
    ApplicationQuantity: '申请件数',
    QuantityToReturn: '需寄回数量',
    CustomerServiceArbitration: '平台处理结果',
    Return: '退货',
    TransactionInformation: '交易信息',
    RefundRequestAmount: '申请退款金额',
    sellerRefusedReturn: '卖家拒绝退货',
    returnReviewApprovedAwaitingShip: '退货审核通过，等待买家发货',
    awaitingBuyerShip: '等待买家发货',
    awaitingSellerReceive: '等待卖家收货',
    afterSalesCompleted: '售后完成',
    ReturnShippingInfo: '退货物流信息',
    ReturnShippingUpdates: '退货物流动态',
    buyerHasShipped: '买家已发货，退货商品运输中',
    ReturnRefund: '退货退款',
    returnItemDeliveredAwaitingSign: '退货商品已送达，等待卖家签收',
    returnCompletedProceedRefund: '退货已完成，进入退款流程',
    noReturnOnlyRefundSuccessful: '无需退货，仅退款成功',
    refundNumber: '退款编号',
    refundTime: '退款时间',
    buyerInitiatesOrderCancellation: '买家发起取消订单',
    sellerReviews: '卖家审核',
    buyerSubmittedOrderCancellation: '买家发起了取消订单申请',
    cancellationInProgressUrgeReview: '取消订单申请进行中，快点审核吧！',
    cancellationRequestApproved: '取消订单申请已通过',
    cancellationApprovedProceedRefund: '取消订单申请已通过，将进入退款流程',
    sellerRejectedCancellation: '卖家拒绝取消订单',
    cancellationRequestRejected: '取消订单申请已被驳回',
    unshippedRefund: '未发货退款',
    AmountApplied: '申请退款金额',
    RefundDestination: '退款去向',
    requestedRefundAmount: '申请退款金额',
    actualRefundAmount: '实际退款金额',
    refundFromSellerToBuyer: '从卖家订单货款退款给买家',
    buyerPaymentMethod: '买家支付方式',
    merchantPayoutMethod: '商家出款方式',
    productPayment: '商品费用',
    autoCancelOrderOnTimeout: '超时自动取消订单',
    autoConfirmReceiptPrompt: '该订单将在',
    receiptDueTime: '后自动确认收货',
    ReturnAndRefundSupported: '支持退货退款',
    ReturnsRefundsNotSupported: '不支持退货退款',
    GotoReview: '去审核',
    reviewTimeoutAutoApproved: '审核已超时，审核自动通过',
    shipmentTimeoutAutoCancelled: '发货已超时，订单已自动取消',
    orderAutoConfirmedReceipt: '订单已自动确认收货',
    Type: '类型',
    returnPath: '退回路径',
    returnPathDetail: '买家-钱包-余额',
    preOrderDepositDeduction: '预订金抵扣',
  },
  entry: {
    settleProcess: '选择入驻类型',
    fillSettleInfo: '填写入驻信息',
    welcomeIndividualMerchant: '欢迎入驻个体经营者',
    fillSubmitInfo: '请填写资料并提交，我们将尽快审核。',
    enterpriseInfo: '企业信息',
    registerNumVatTip: '注册编号与增值税号两项信息，',
    fillAtLeastOne: '最少填写一项',
    otherwiseRejectAudit: '否则将无法审核通过！',
    returnSelectOtherBizMode: '返回选择其他经营模式',
    shopName: '店铺名称',
    enterpriseName: '企业名称',
    enterpriseNamePlaceholder: '请输入企业名称',
    country: '所在国家',
    countryPlaceholder: '请选择企业所在国家',
    registrationPlaceholder: '请输入企业注册编号',
    vatPlaceholder: '请输入企业增值税号',
    eoriTaxNumber: 'EORI税号',
    eoriPlaceholder: '请输入英国EORI进出口税号',
    eoriPlaceholderCn: '请输入EORI进出口税号',
    vatRegistrationNum: '增值税号',
    eoriNumber: 'EORI号',
    certificateFiles: '证明文件',
    certificateFilesHelp: '企业注册文件、增值税凭证或英国 EORI 进出口税号材料',
    certificateFilesHelpCn: '企业注册文件、增值税凭证或 EORI 进出口税号材料',
    contract: '合同',
    contractTemplate: '上传相关合同文件',
    downloadContractTemplate: '下载 HURIX 货主服务合同模板',
    uploadFilesTip: '上传相关文件（Image、PDF），最多5个文件',
    withdrawContract: '合同',
    withdrawContractHelp: '加盖公章的合作商业协议，用于营收款项提现至中国大陆账户',
    withdrawContractUploadTip: '上传签署完成的 HURIX 货主服务合同（仅支持PDF）',
    withdrawContractHurix:'HURIX 货主服务合同',
    withdrawContractH:'货主服务合同',
    personalInfo: '个人信息',
    legalPersonInfo: '法人信息',
    ensureInfoAccurate: '请确保信息准确无误',
    idProof: '身份证明',
    idFullName: '证件全名',
    submitAudit: '提交审核',
    submitFailed: '提交失败',
    prompt: '提示',
    submitSuccessTip: '提交成功，审核结果将会通过邮件方式通知您！',
    individualMerchant: '个体经营者',
    suitableForIndividual: '适合营业执照类型为“个体工商户”',
    settleNow: '立即入驻',
    approxThirtyMins: '约30分钟',
    operatorIdMaterials: '、经营者身份证件、合同等相关资质材料',
    queryMaterials: '查询资料',
    platformAudit: '平台审核',
    approxOneToThreeWorkdays: '约1-3个工作日',
    platformAuditMaterials: '平台审核相关资质材料',
    enterpriseCompany: '企业公司',
    suitableForEnterprise: '适合营业执照类型为“公司/企业/个人独资企业等',
    submitMaterials: '提交材料',
    uploadBizLicAndId: '上传营业执照、法定代表身份证件等相关资质材料',
    accountVerification: '账户验证',
    realNameOrCompanyPayVerify: '实名认证或对公账户打款验证',
    welcomeMerchant: '欢迎入驻公司/企业经营者',
    threeInfoItems: '注册编号、增值税号、EORI税号三项信息',
    hasAccount: '已有账号？立即登录',
    hasAccountS: '已有账号？',
    hasAccountLogin: '立即登录',
    registerAccount: '账号注册',
    inputID: '请输入您的有效护照或英国驾照',
    inputIDCn: '请输入您的有效护照或驾照',
    inputIDCardCn: '请输入您的有效身份证',
    nameConsistent: '必须与您提供的身份证明文件上的姓名一致',
    ukNoChineseAllowed: '选择英国时，企业名称和证件全名不能输入中文',
    ukShopNameNoChineseAllowed: '选择英国时，企业名称不能输入中文',
    cnShopNameNoChineseAllowed: '选择中国时，企业名称只能输入中文',
    ukCertificateUsernameNoChineseAllowed: '选择英国时，证件全名只能输入英文',
    cnOnlyChineseAllowed: '选择中国时，证件全名只能输入中文',
    storeReviewing: '您的店铺平台正在审核中，审核结果将以邮件形式通知',
    applicationRejected: '您的店铺申请被驳回，是否重新提交申请',
    checkTheInstruction: '请阅读并勾选说明',
    countrySelectBrand: '卖家中心',
    countrySelectDefaultAccount: '卖家',
    countrySelectAgreementPrefix: '您授权“卖家中心”与',
    countrySelectAgreementSuffix: '共享您的账号ID和店铺名称，并已阅读并同意',
    countryUkTitle: '英国',
    countryCnTitle: '中国',
    countryEnter: '进入',
    countryNonUkTitle: '非英国',
    countryNonUkSubtitle: '其他地区',
    registerSuccess: '账号注册成功！',
    registerFail: '注册失败',
    linkExpired: '链接已失效',
    operator: '操作员',
    inviteOperator: '邀请操作员',
    inviteOperatorByEmail: '通过电子邮件邀请操作员加入 {shopName}',
    sendInvite: '发送邀请',
    registered: '已注册',
    linkTitle1: '邀请链接已失效',
    linkTitle2: '链接已失效',
    message1: '抱歉，您访问的邀请链接已过期或失效，请联系主账号重新发送邀请!',
    message2: '抱歉，您访问的链接已过期或失效!',
    reasons_24: '链接已超过24小时有效期',
    reasons_7: '链接已超过7天有效期',
    reasons2: '子账号已完成注册',
    possibleReason: '可能的原因',
    invitationEmail: '操作员邮箱将收到一封邀请邮件',
    bizSubjectTip1: "适合企业/公司/品牌方/供应链等经营主体",
    bizSubjectTip2: "适合以个人身份开展商业经营的经营者",
    corpNameTip: "企业名称（与营业执照一致）",
    corpRegNoLabel: "企业注册编号",
    corpRegNoPlaceholder: "请输入企业注册编号（如： 12345678）",
    corpRegNoDesc: "请填写政府/工商部门颁发的企业注册编号",
    regCountryArea: "注册国家/地区",
    corpInfoTip: "请填写企业真实信息，用于平台审核及合规管理",
    selectProvinceCityDistrict: "请选择省/市/区",
    ukVatLabel: "英国VAT号码",
    ukVatPlaceholder: "请输入有效的英国VAT号码（如：GB123456789）",
    ukVatDesc: "请输入您在英国税务局（HMRC）注册的VAT号码，平台将快速验证",
    importantNote: "重要说明",
    vatVerifyTip1: "平台将通过HMRC系统验证VAT号码的有效性",
    vatVerifyTip2: "以及公司注册地址判断企业是否为英国本土企业",
    vatEffectTip: "VAT信息将影响平台后续的税务处理规则",
    vatEffectTip3: "提现账户须与注册主体保持一致",
    contactPhonePlaceholder: "请输入联系电话",
    contactEmailPlaceholder: "请输入联系邮箱",
    contactPhoneLabel: "电话号码",
    contactEmailLabel: "联系邮箱",
    legalRepInfoTitle: "法定代表人信息",
    legalRepKycTip: "用于身份核实 KYC",
    legalRepNameLabel: "法定代表人姓名",
    legalRepIdTypeLabel: "法定代表人身份证件类型",
    legalRepIdNoLabel: "法定代表人身份证件号码",
    legalRepIdUploadLabel: "上传法定代表人身份证件",
    legalRepNamePlaceholder: "请输入法定代表人姓名（与证件一致）",
    idTypeSelectPlaceholder: "请选择证件类型",
    idPortraitSide: "证件人像面",
    idInfoSide: "证件信息面",
    corpProofTitle: "企业主体证明",
    requiredTag: "必填",
    companiesHouseLabel: "公司注册证明",
    companiesHouseDesc: "用于验证企业在英国合法注册的主体信息和注册地址",
    supportFileTitle: "支持文件",
    incorporationFileTip: "Certificate of Incorporation / Companies House 注册证明（含公司名称、注册编号、注册日期、注册地址）",
    ukVatCertLabel: "英国VAT注册证明",
    ukVatCertDesc: "用于验证VAT号码的真实性及注册主体信息",
    hmrcVatFileName: "HMRC VAT Registration Certificate / VAT Confirmation",
    supplementaryProofTitle: "补充证明材料",
    optionalTag: "可选",
    companyConstitutionLabel: "公司章程/组织大纲及章程",
    companyConstitutionDesc: "用于进一步核实公司治理结构及经营范围",
    companyConstitutionEnTip: "Memorandum & Articles of Association",
    businessAddrProofLabel: "实际经营地址证明",
    businessAddrProofDesc: "用于验证公司实际经营地址（如注册地址与实际经营地址不一致时）",
    businessAddrFileTip: "银行对账单/水电费账单/商业租赁合同等（需体现公司名称及地址，3个月内出具）",
    bankAccountProofLabel: "银行账户证明",
    bankAccountProofDesc: "用于验证公司银行账户信息",
    bankAccountFileTip: "银行证明信/对账单（需体现公司名称、账号或IBAN，3个月内出具）",
    personalInfoTitle: "个人信息",
    personalNameLabel: "姓名（与证件一致）",
    birthDateLabel: "出生日期",
    nationalityAreaLabel: "国籍/地区",
    personalNamePlaceholder: "请输入您的姓名",
    birthDatePlaceholder: "请选择出生日期",
    nationalityAreaPlaceholder: "请选择国籍/地区",
    idVerifyTitle: "身份验证",
    idUploadTip: "请上传政府签发的有效身份证明文件",
    idTypeLabel: "证件类型",
    ukPassportOption: "英国护照",
    ukDrivingLicenceOption: "英国驾驶执照",
    idUploadLabel: "上传身份证明文件",
    idFrontSide: "证件正面",
    idBackSide: "证件反面（如适用）",
    selfieWithIdLabel: "本人手持证件自拍照",
    holdIdSelfieUploadTip: "请上传本人手持证件自拍照",
    selfieWithIdTip: "请手持身份证件拍照，确保证件信息清晰可见。",
    residenceVerifyTitle: "居住地址验证",
    residenceVerifyTip: "请提供近3个月内的居住地址证明文件，以下任选其一上传",
    bankStatementItem: "银行流水（近3个月）",
    bankStatementDesc: "需包含您的姓名、账户信息及交易记录。",
    utilityBillItem: "水电燃气账单（近3个月）",
    utilityBillDesc: "需包含您的姓名、地址及账单日期。",
    netMobileBillItem: "网络/手机账单（近3个月）",
    netMobileBillDesc: "需包含您的姓名、地址及账单日期。",
    rentalContractItem: "租房合同（有效期内）",
    rentalContractDesc: "需包含您的姓名、地址、租期及签署日期。",
    addressProofUploadLabel: "上传地址证明文件",
    salesChannelTitle: "销售渠道信息",
    mainSalesChannelTip: "请选择您目前的主要销售渠道（可多选）",
    channelIndependentSite: "独立站",
    channelOffline: "线下销售",
    channelOther: "其他",
    otherSalesChannelPlaceholder: "请填写其他销售渠道",
    shopLinkTip: "如果您有线上店铺，请提供店铺链接（选填）",
    shopLinkPlaceholder: "请输入店铺链接（例如：https://www.tiktok.com/@yourshop）",
    offlineBizTitle: "线下经营信息（如适用）",
    shopNameLabel: "店铺名称（选填）",
    shopNamePlaceholder: "请输入店铺名称",
    shopAddressLabel: "店铺地址（选填）",
    shopAddressPlaceholder: "请输入店铺地址",
    shopPhotoLabel: "门店照片（选填，最多5张）",
    fileFormatSizeTip: "支持JPG、PNG、PDF格式，大小不超过10MB",
    uploadIdBothSideTip: "请上传证件人像面及证件信息面",
    uploadCompaniesHouseTip: "请上传公司注册证明",
    uploadVatCertTip: "请上传VAT注册证明",
    uboTitle: "企业受益所有人（UBO）",
    uboTip: "如您的企业存在25%以上股权/投票权的自然人，请提供受益所有人姓名",
    uboNamePlaceholder: "请输入受益所有人姓名",
    idPagePersonalInfo: "个人信息页",
    idPageSignature: "个人签名页",
    drivingLicenceFront: "驾照正面",
    drivingLicenceBack: "驾照反面",
    proofFileTypePlaceholder: "请选择证明文件类型",
    vatTip1: "可开具增值税发票",
    vatTip2: "可进行VAT合规结算",
    vatTip3: "享受全部平台功能",
    vatTip4: "个人身份认证",
    vatTip5: "个人经营主体入驻",
    vatTip6: "根据实际情况提供VAT信息",
    onboardTypeTip1: "请选择入驻类型",
    onboardTypeTip2: "请选择与您经营主体一致的入驻类型",
    tagRecommend: "推荐",
    tagIndividualOnboard: "个体入驻",
    nextStepFillInfo: "下一步：填写信息",
    stepEnterpriseInfo: "企业信息填写",
    stepUploadQualification: "上传资质",
    stepOnboardSuccess: "入驻成功",
    fileFormatTip: "支持 JPG、PNG、PDF 格式，大小不超过 10MB",
    viewExample: "查看示例",
    docRule1: "文件必须清晰可见，信息完整，无遮挡，无反光",
    docRule2: "内容真实有效，不得篡改或伪造",
    docRule3: "文件为彩色扫描件或清晰照片",
    docRule4: "单个文件大小不超过 10MB",
    docRule5: "支持 JPG、PNG、PDF 格式",
    uploadReqTitle: "上传要求",
    fileSampleTitle: "文件示例",
    faqTip1: "点击“查看示例”可预览大图",
    faqTitle: "常见问题",
    faqQ1: "Q：提交的公司注册证明需要最新的吗？",
    faqA1: "A：建议提供最新的 Companies House 注册信息，更新时间不超过 3 个月。",
    faqQ2: "Q：如果注册地址与实际经营地址不一致怎么办？",
    faqA2: "A：请同时提供实际经营地址证明文件，用于平台核实。",
    importantNoteTitle: "重要说明",
    importantNoteDesc: "所有文件必须真实有效，信息清晰可见，无遮挡、无反光；文件需为彩色扫描件或清晰照片，内容完整；平台将对提交的资料进行审核，虚假信息可能导致审核失败或账户受限。",
    sloganText: "合规经营 · 诚信共赢",
    onboardStep1: "选择入驻类型",
    onboardStep2: "经营者信息",
    onboardStep3: "资质上传",
    onboardStep4: "平台审核",
    onboardStep5: "入驻成功",
    complianceTipLabel: "合规提示",
    complianceTipDesc: "为保障平台交易安全及符合监管要求，所有卖家均需完成真实身份及企业信息认证，HURIX将根据您的信息进行审核。",
    auditReviewStatus: "审核中",
    auditSubmittedTitle: "资料已提交，正在审核",
    auditSubmittedDesc: "我们会核对经营主体、身份与资质材料。预计 1–3 个工作日完成，并通过联系邮箱通知审核结果。",
    auditMaterialNotice: "资料仅用于入驻审核",
    auditAcknowledged: "我已知晓",

    store: {
      title: '关联店铺信息（至少提供一种）',
      addStore: '+ 添加更多店铺',
      deleteStore: '删除店铺',
      onlineStore: '线上店铺',
      platformType: '平台类型',
      platformTypePlaceholder: '请选择平台类型',
      storeUrl: '店铺链接',
      storeUrlPlaceholder: '请输入您的店铺链接',
      storeName: '店铺名称',
      storeNamePlaceholder: '请输入店铺名称',
      physicalStoreInformation: '实体店铺信息',
      storeAddress: '店铺地址',
      storeAddressPlaceholder: '请输入店铺详细地址',
      storeImage: '店铺照片',
      hasPhysicalStore: '有实体店铺',
      noPhysicalStore: '无实体店铺',
      uploadImage: '点击上传',
      chooseFile: '选择文件',
      uploadImageTip: '支持图片，最多上传10张',
      imageExample: '示例：门店门头、店内环境实拍图'
    },

    validation: {
      platformType: '请选择平台类型',
      storeUrl: '请输入店铺链接',
      storeName: '请输入店铺名称',
      storeAddress: '请输入店铺地址',
      storeImage: '请上传店铺照片',
      duplicateStore: "该店铺已重复",
    }
  },
  verifyWithdraw: {
    currentPayee: '当前提现账户主体',
    alertBanner: '为保障资金安全，请先验证收款信息',
    payeeInfo: '收款人信息',
    payeeBankAccountInfo: '收款人银行卡账户信息',
    bankAccountName: '账户持有人全名',
    enterBankAccountName: '与银行记录完全一致',
    firstName: '名',
    enterFirstName: '请输入名',
    lastName: '姓',
    enterLastName: '请输入姓',
    companyRegistrationNumber: '公司注册号',
    enterCompanyRegistrationNumber: '请输入公司注册号',
    legalRepresentativeName: '法人姓名',
    enterLegalRepresentativeName: '请输入法人姓名',
    idNumber: '证件号',
    enterIdNumber: '请输入证件号',
    payeeBankAccountNumber: '银行账号',
    enterBankAccountNumber: '请输入银行账号',
    bankName: '银行名称',
    enterBankName: '请输入银行名称',
    enterBankNameToSearch: '请输入银行名称搜索',
    sortCode: 'Sort Code',
    enterSortCode: '请输入Sort Code',
    sortCodeError: 'Sort Code格式应为XX-XX-XX',
    cnapsCode: '支行代码(联行号)',
    enterCnapsCode: '通过手机银行查询支行代码(联行号)并输入',
    branchCode: '联行号',
    enterBranchCode: '请输入联行号',
    enterBranchCodeShort: '请输入联行号',
    ukAccountNoError: '银行卡号需为7-8位纯数字',
    cnAccountNoError: '银行卡号需为12位纯数字',
    cnAccountNameOnlyChinese: '请输入与银行账户一致的中文全名',
    nonCnAccountNameNoChinese: '请输入与银行账户一致的英文全名',
    nonCnBankNameNoChinese: '非中国地区银行名称不能输入中文',
    remark: '备注',
    enterRemarkOptional: '请输入备注（选填）',
    editWithdrawInfo: '编辑收款信息',
    createAccount: '创建账户',
    fetchBankListFailed: '获取银行列表失败',
    withdrawAmountTip: '只能输入不小于0的数字',
    feeTip: '* 提现需扣除 {feeRate} 的手续费，预计扣除 £{feeAmount}',

    feeTipFull: '您本次提现金额为<span class="fee-highlight">£{amount}</span>，将按<span class="fee-highlight">{feeRate}</span> 收取手续费。预计扣除手续费<span class="fee-highlight">{fee}</span>，实际到账金额为<span class="fee-highlight">{actualAmount}</span>。提现即视为同意该费用，具体结汇费用以入账实时汇率为准。',
    noChangesToSave: '当前没有修改任何信息，无需保存',
  },
  myAccount: {
    withdrawContractInfo: '提现合同资料',
    withdrawContract: '合同资料',
    withdrawContractTemplateDownload: '合同模板'
  },
  wallet: {
    OtherCreditCardPayment: '其它信用卡支付',
    CreditCardEnding: '尾号为cardNumber的信用卡',
    OnlyVisaMastercard: '仅支持Visa和Mastercard卡',
    AddCreditCard: '添加信用卡',
    CardNumber: '卡号',
    CardholderName: '持卡人姓名',
    CardHolder: '持卡人',
    ExpiryDate: '到期日',
    SecurityCode: '安全代码(CVV)',
    checkCodeVisa: '信用卡或借记卡背面的三位数验证码被称为卡验证值（CVV）或卡验证码（CVC）',
    prefixOfCardNumber: '卡号必须以 4 开头，或者在 51 到 55 之间，或者在 2221 到 2720 之间',
    lengthOfCardNumber: '卡号长度只能是13或者16',
    EditCreditCard: '编辑信用卡',
    RemoveCreditCard: '移除信用卡',
    sureRemoveCreditCard: '是否确认移除信用卡？',
    creditCardInformation: '信用卡信息',
    month: '月',
    year: '年',
    BillingAddress: '账单地址',
    editNewBillingAddress: '编辑一个新的账单地址',
    payNow: '立即支付',
    ShippingAddress: '收货地址',
    Type: '类型',
    SelectBillingAddress: '选择一个账单地址',
    PleaseSelectBillingAddress: '请选择一个账单地址',
    AllDataProtected: '所有数据均受到保护',
    cardParameterError: '参数错误，请核对您的信用卡信息',
    CreditCard: '信用卡',
    transactionsAreSecureEncrypted: '所有交易都是安全且加密的',
    sureUseCreditCard: '确认使用尾号cardNumber的信用卡进行支付',
    CurrentBalance: '当前余额',
    AvailableBalance: '可用余额',
    FrozenAmount: '冻结金额',
    TransactionHistory: '交易流水',
    WithdrawalProgress: '提现中',
    transferIn: '转入',
    withdrawal: '提现',
    repurchase: '复购',
    repurchaseRefund: '复购退款',
    SerialNumber: '流水号',
    TransactionID: '交易单号',
    CreationDate: '创建日期',
    IncomeExpenseType: '收支类型',
    Income: '收入',
    Expense: '支出',
    TransactionType: '交易类型',
    BankCardNumber: '银行卡号',
    WithdrawalRemarks: '提现备注',
    WithdrawStatus: '提现状态',
    WithdrawFailReason: '提现失败原因',
    WithdrawStatus1: '创建',
    WithdrawStatus2: '余额充值中',
    WithdrawStatus3: '结汇订单审核中',
    WithdrawStatus4: '提现中',
    WithdrawStatus5: '提现成功',
    WithdrawStatus6: '提现失败',
    ConfirmWithdrawal: '确认提现',
    WithdrawAllFunds: '全部提现',
    surePayWithBalance: '是否确认使用余额支付？',
    Balance: '余额',
    amountCannotBeZero: '提现金额不能为零',
    amountMustBeGreaterThan50: '提现金额不能小于50',
    ConfirmPay: '确认并支付',
    CVVMustDigits: '请输入 CVV，且必须为 3 位数字',
    ProcessingPayment: '支付中',
    committedProtectingInformation: '慧清仓致力于保护您的付款信息',
    paymentNotSuccessful: '您尚未支付成功',
    cardIssuerDeclinedTransaction: '您的发卡机构拒绝交易。请联系发卡机构获取进一步支持或尝试其他卡或付款方式。',
    wasNotCharged: '信用卡未被收取费用',
    SomeCommonIssues: '一些常见问题和解决方案:',
    VerifyPaymentInformation: '验证您订单中输入的付款信息',
    bankHaveFlagged: '你的银行可能将此标记为异常活动',
    withdrawalPurchaseLimits: '确认银行每日提款或购买限额',
    PaymentSuccessful: '支付成功',
    paymentStatusQuerying: '支付结果查询中...',
    paymentAmount: '支付金额',
    antoClose: 'x 秒后自动关闭',
    bingCardTip: '卡片验证需支付 £1-£2 随机金额，验证成功后金额转入余额。',
    bingCardTipSeller: '店铺【x】需要预平账。',
    bingCardTipOperator: '店铺【x】需要预平账，请联系货主。',
    bindNow: '去平账',
    bankCard: '银行卡',
    setPaymentPassword: '设置支付密码',
    modifyPaymentPassword: '修改支付密码',
    pleaseSetPaymentPasswordFirst: '请先设置支付密码',
    goToSet: '去设置',
    enterSixDigitPaymentPassword: '输入六位数字的支付密码',
    pleaseEnterSixDigitPaymentPassword: '请输入六位数字的支付密码',
    paymentPasswordSetSuccess: '支付密码设置成功！',
    pleaseEnterPaymentPassword: '请输入支付密码',
    forgotPaymentPassword: '忘记支付密码？',
    preOrderRelease: '预订单释放',
    preOrderDepositRefund: '预订单定金退款',
    preOrderExpiryRefund: '预订单到期退款',
    estimatedDebt: '预估经营欠款 - 平账',
    platformSettlement: '平台结算',
    platformSubsidies: '平台补贴 - 其他',
    pleaseEnterNewPaymentPassword: '请输入新的支付密码',
    enterNewPaymentPassword: '输入新的支付密码',
    confirmNewPasswordAgain: '再次确认新密码',
    pleaseEnterOriginalPwdForModifyConfirm: '请输入原支付密码，确认您的密码修改操作',
    modifyPaymentPasswordSuccess: '修改支付密码成功',
    enterValidBankCardNumber: '请输入有效的银行卡号',
    deductionStatus: '扣款状态',
    success: '成功',
    failed: '失败',
    deductionMethod: '扣款方式',
    paymentStatus: '支付状态',
    paymentProcessing: '支付进行中',
    paymentSuccess: '支付成功',
    paymentCancelled: '支付取消',
    paymentFailed: '支付失败',
    failureReason: '失败原因',
    myBankCard: '我的银行卡',
    myBalance: '我的余额',
    withdrawalAmount: '提现金额',
    currentSettlementCycle: "当前结算周期：",
    // 收款设置相关
    collectionSettings: '收款设置',
    collectionSettingsSubtext: '若要通过新账号收款，请更新收款账号',
    collectionAccount: '收款账号',
    valid: '有效',
    invalid: '无效',
    reviewing: '审核中',
    pleaseVerifyPayeeInfo: '请核实收款人信息',
    payeeInfoUnderReview: '收款人信息审核中，预计1个工作日完成',
    update: '更新',
    fullBankCardNumber: '完整卡号',
    confirm: '确定',
    failedToGetFullCardNumber: '获取完整银行账号失败',
    failedToGetFullCardNumberRetry: '获取完整银行账号失败，请稍后再试',
    operationFailedRetry: '操作失败，请稍后再试',
    // 新增缺失的国际化文本
    noPayeeAccountInfo: '暂无收款账号信息',
    errorUpdatingPayee: '处理更新收款人信息时出错:',
    estimatedEarnings: '的预估收益',
    estimatedEarning: '预估收益',
    estimatedDebtDetails: '预估收益',
    estimated: '预估欠款',
    storeRent: '店租',
    storageFee: '仓储费',
    currentPaymentIncludesProcessingFee: '本次支付将扣除£x手续费，实际到账金额将转入余额',
    minimumPaymentAmount: '本次最小支付金额',
    minPriceCalculation: '最小支付金额(£) = 预估欠款 * 1.2 - 可用余额',
    selectPaymentMethod: '请选择支付方式',
    hours: ':',
    minutes: ':',
    seconds: '',
    estimatedAdjustmentAmount: "预平账金额",
    pendingAdjustment: "待平账",
    adjustmentNote: "预平账将直接充值至余额，用于后续提现或抵扣",
    welcomeMessage: '你好，欢迎使用微信付款！',
    myCheckout: '我的收银台',
    transactionNotice: '正在使用即时到账交易，交易将在 ',
    afterClose: ' 后关闭，请及时付款！',
    openWechat: '打开手机微信',
    scanToPay: '扫一扫继续付款',
    qrExpired: '二维码已过期',
    firstUseDownload: '首次使用请下载手机微信',
    networkTimeout: '网络超时，请重新加载......',
    redirectNotice: '秒后进行跳转',
    bankCardNumber: "请输入18位以内的纯数字银行卡号",
    amount: "金额",
  },
  authorized: {
    connectShopify: "连接shopify",
    afterSyncYouCan: '同步完成后，您可以：',
    apiLimitPhenomenon: '现象：同步部分商品后停止，提示"API调用频率限制"',
    authorizationExpired: '授权过期',
    authorizationExpiredPhenomenon: '现象：同步时提示"授权已过期"或"无权限访问"',
    authorizationExpiredSolution: '解决方法：重新授权第三方平台',
    authorizationExpiryReminder: 'dayNum天后过期',
    authorizationInstructions: '授权说明',
    authorizationManagementDescription: '授权管理说明',
    authorizationManagementDetails: '在此页面可以管理您的TikTok、亚马逊、Temu和Shopify平台授权信息。',
    authorizationManagementDetails2: '授权成功后，您可以查看和管理已授权的店铺信息。 授权信息将安全存储，您可以随时撤销授权。',
    authorizationProcessing: '授权处理中，请耐心等待',
    authorizationStatus: '授权状态',
    authorizationTime: '授权时间',
    authorize: '授权',
    authorized: '已授权',
    authorizedStoreInfo: '已授权店铺信息',
    avoidInvalidSync: '避免无效同步：已下架或禁售的商品可能在第三方平台已不存在',
    batchSyncGoods: '分批次同步商品',
    cancelAuthSyncTip: '取消授权后，系统将停止处理正在同步的商品哦！',
    cancelAuthorization: '取消授权',
    checkInfoBeforeSync: '同步前检查第三方平台的商品信息是否准确完整',
    checkNetworkConnection: '检查您的网络连接是否正常',
    checkSyncRecord: '您可以在【商品同步记录】中查看实时进度',
    collectMerchantFeedback: '我们正在收集商家反馈，未来可能会增加自定义规则的功能。',
    complianceRequirements: '合规要求：确保商品符合法律法规和平台政策',
    confirmAuthorizationPrompt: '您还没有授权应用，去授权？',
    confirmErrorType: '1. 确认错误类型',
    confirmRevokeAuthorization: '是否确认取消授权',
    confirmStoreInfo: '确认店铺信息',
    confirmStoreInfoDesc: '请您再次确认授权的店铺信息。若信息未确认，会导致订单同步等相应功能无法正常使用',
    confirmSync: '确认同步',
    consumerRights: '消费者权益：提供完整的商品信息保障消费者知情权',
    contactTechSupport: '如果多次失败，请联系技术支持',
    crossBorderEcommercePlatform: '跨境电商平台',
    dataConsistency: '数据一致性：确保 HURIX 上的商品状态与第三方平台一致',
    defaultRuleSystemPreset: '当前版本的默认值处理规则是系统预设的，暂时不支持修改。这些规则的设计基于：',
    ensureGoodsValidity: '确保商品有效性：上架中的商品代表正在销售，信息完整有效',
    faqTitle: '常见问题解答',
    faqTitle1: '商品同步需要多长时间？',
    faqTitle2: '为什么只同步上架中的商品？',
    faqTitle3: '默认值处理规则',
    faqTitle4: '同步失败常见原因及解决方法',
    faqTitle5: '为什么需要补充商品审核材料？',
    faqTitle6: '同步后商品信息错误怎么办？',
    globalEcommercePlatform: '全球电商平台',
    goToAuthorize: '去授权',
    goodsExpirationDesc: '从第三方同步的商品，商品到期时间默认设置为1年',
    goodsExpirationTime: '商品到期时间',
    goodsQuantity: '商品数量：商品数量越多，同步所需时间越长',
    imageSize: '图片大小：如果同步商品图片，图片大小会影响同步速度',
    incompleteInformation: '信息不完整：确认第三方平台商品信息是否完整',
    independentEcommercePlatform: '独立站电商平台',
    industryBestPractices: '行业最佳实践：根据电商行业的通用标准制定',
    informationCompleteness: '信息完整性：HURIX 要求商品信息完整才能上架销售',
    inventoryError: '库存错误：确认第三方平台的库存数量',
    maintainDataConsistency: '数据一致性：保持商品信息的统一规范',
    manualAftersalesNote: '在特定情况下需要人工介入处理售后事宜。',
    manuallyAddOnHurix: '或手动在 HURIX 添加该商品',
    manuallyEditNeededGoods: '对需要调整的商品进行手动编辑',
    manuallyModifyOnHurix: '手动修改：在 HURIX 商品管理页面直接编辑商品信息',
    merchantSku: '商家SKU',
    merchantSkuDesc: 'HURIX 的商家SKU优先使用第三方的商家SKU，当商家SKU获取失败时取第三方的商品ID作为 HURIX 的商家SKU',
    missingImages: '图片缺失：检查第三方平台是否提供了商品图片',
    needSyncOffSaleGoods: '如果您需要同步已下架的商品，可以：',
    networkCondition: '网络状况：与第三方平台的网络连接速度',
    networkConnectionIssues: '2. 网络连接问题',
    networkIssuesPhenomenon: '现象：同步进度长时间卡住或报网络错误',
    noAuthorizedStoreTip: '该平台下暂无已授权店铺，请先前往授权页面绑定店铺',
    optimizeUserExperience: '用户体验优化：减少商家手动配置的工作量',
    orderStatusSyncAfterAuth: '授权后，HURIX 将同步第三方平台的商品信息：',
    partialPlatformMaterialEmpty: '部分第三方平台的商品审核材料可能为空，需要补充的原因：',
    partialSuccess: '部分成功',
    pendingSync: '待同步',
    permanentAuthorization: '永久授权',
    platformComplianceRequirements: '平台合规要求：确保符合 HURIX 平台的政策要求',
    platformPolicyDifferences: '平台政策差异：不同平台对审核材料的要求不同',
    platformRestrictions: '平台限制：部分第三方平台的API调用频率限制',
    preventiveMeasures: '3. 预防措施',
    priceError: '价格错误：检查第三方平台的价格是否已更新',
    priceSetting: '价格设置',
    priceSettingDesc: 'HURIX 售价与市场参考价统一使用第三方商品定价',
    processing: '处理中',
    productSync: '商品同步',
    reExecuteSyncOnHurix: '然后在 HURIX 重新执行同步操作',
    reListOnThirdPlatform: '先在第三方平台重新上架该商品',
    reSyncAfterUpdate: '重新同步：在第三方平台更新信息后，重新执行同步操作',
    reduceSingleSyncQuantity: '减少单次同步的商品数量',
    referenceLink: '参考链接',
    referenceLinkDesc: '参考链接默认使用第三方商品的详情页面链接',
    regularlySyncGoods: '定期同步商品，确保信息及时更新',
    retrySyncLater: '稍后重试同步操作',
    revokeAuthorizationSuccess: '取消授权成功',
    saveModifications: '保存修改后，商品将按照您的设置展示',
    saveResources: '节省资源：减少不必要的同步操作，提高效率',
    selectAuthorizedStore: '请选择授权店铺',
    selectPlatform: '选择平台',
    selectPlatformPlaceholder: '请选择第三方平台',
    selectStore: '选择店铺',
    selectStorePlaceholder: '请选择对应平台店铺',
    selectThirdPartyPlatformForSync: '请选择第三方平台进行订单同步，未授权平台请先授权后再操作',
    selectXItems: '已选择 x 个商品',
    setPriceInventoryAlerts: '设置价格/库存变化提醒，及时同步更新',
    shortVideoEcommercePlatform: '短视频电商平台',
    solutionMethods: '2. 解决方法',
    step1Desc: '系统仅同步当前在售的商品，已下架或禁售商品不会同步到HURIX。',
    step1Title: '仅同步上架中/售卖中的商品',
    step2Desc: '第三方平台店铺的商品同步至 HURIX 后，将统一处于草稿箱中。',
    step2Title: '商品同步后自动进入草稿箱',
    step3Desc: '同步完成后，卖家可进入【草稿箱】完善商品剩余属性',
    step3Title: '卖家完善商品信息',
    storeId: '店铺ID',
    storeName: '店铺名称',
    sync100Goods: '100个商品同步大约需要5-8分钟',
    syncAlert: '部分第三方平台的商品审核材料可能为空，当您编辑商品时，需要补充完善商品审核材料以确保顺利上架。',
    syncAuthorizedStoreProducts: '商品同步任务设置',
    syncAuthorizedStoreTips: '先授权第三方平台店铺，再同步商品至HURIX，支持查看历史同步记录',
    syncFailed: '同步失败',
    syncFailureTroubleshoot: '如果同步失败，请按照以下步骤排查：',
    syncGoodsInfoError: '如果同步后商品信息出现错误，请按以下步骤处理：',
    syncProducts: '同步商品',
    syncRecords: '商品同步记录',
    syncResult: '同步结果',
    syncStatus: '同步状态',
    syncSuccess: '同步成功',
    syncTime: '同步时间',
    syncTimeDepends: '同步时间取决于以下因素：',
    syncTimeNormal: '通常情况下：',
    systemOnlySyncOnSale: '系统仅同步上架中/售卖中的商品，主要基于以下考虑：',
    thirdPartyReturnImportantNote: '重要提示',
    thirdPlatformRestrictions: '3. 第三方平台限制',
    unauthorized: '未授权',
    viewSyncedGoods: '在商品管理页面查看已同步的商品',
    waitBeforeReSync: '等待一段时间后重新同步',
    fillShopifyDomain: '请输入您的shopify商店地址',
    shopifyDomainRule: 'Shopify商店域名不得包含http、https，格式示例：xxx.myshopify.com',
    cancelAuthFail: "取消授权失败，请检查店铺状态或授权状态",
    deleteAuthConfirm: "是否确认删除店铺授权？",
    storeAuthCancelFail: "店铺授权取消失败，您可以选择删除当前店铺信息，是否删除？",
    authCrossShop: "授权跨境店",
    authLocalShop: "授权本土店",
    crossBorder: "跨境",
    local: "本土",
    shopType: "店铺类型",
    authExpire: "授权到期",
    unlockTip: "功能解锁中，即将上线",
    localStore: "本土店",
    crossStore: "跨境店",
  },
  financeBill: {
    title: '账单',
    status: '账单状态',
    all: '全部',
    processing: '处理中',
    paid: '已支付',
    closed: '已关闭',
    createdAt: '账单创建时间',
    createdFrom: '账单创建时间 开始日期',
    endDate: '结束日期',
    billId: '账单 ID',
    billType: '账单类型',
    reset: '重置筛选',
    amountDue: '应付金额',
    amountPaid: '已支付金额',
    total: '总计',
    purpose: '付款目的',
    actions: '操作',
    viewDetails: '查看详情',
    details: '账单详情',
    empty: '目前暂无任何内容',
    loadFailed: '账单加载失败，请稍后重试'
  },
  billManagement: {
    pageDescription: '管理您的账单、结算和预估负债，查看详细的财务信息',
    estimatedEarnings: '预估收益',
    estimatedEarningsDesc: '查看当前结算周期内的预估收益情况，包括各项费用和支出的详细信息',
    pendingSettlementOrders: '待结算订单',
    pendingSettlementDesc: '尚未结算的订单金额，包括已完成但未达到结算条件的订单',
    settledOrders: '已结算订单',
    settledOrdersDesc: '已完成结算的订单记录，包括结算时间、金额和状态等信息',
    payableAmount: '应付金额',
    payableAmountDesc: '当前需要支付的金额，包括各项费用和扣款明细'
  },
  editor: {
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    uploading: '上传中...',
    maxLengthExceeded: '已超过最大字符数限制：{max}',
    maxImagesExceeded: '最多只能上传{max}张图片',
    characters: '字符',
    images: '张图片',
    onlyEnglishAllowed: '仅允许英文字母',
    contentNotMeetRequirements: '内容不符合要求'
  },
  finance: {
    expectedNetSales: '预计净销售额',
    expectedShipping: '预计运费',
    expectedFees: '预计费用',
    productCard: '商品卡',
    platformShipping: 'HURIX 运费',
    actualShippingHint: '实际运费将按运费价目表收取。',
    estimatedShippingTip: '预计运费仅供参考，实际运费以运费价目表为准。',
    netSalesTip: '扣除所有适用商家折扣后的总成交额。',
    netShippingTip: '与运费相关的借贷项。',
    feesTip: '因使用HURIX服务而收取的费用，如交易手续费、HURIX佣金费。',
    totalSalesTip: '扣除商家或HURIX折扣前的总成交额。',
    salesRefundsTip: '享受商家折扣前的退款 SKU 小计',
    sellerDiscountsTip: '商家折扣是由商家赞助的促销活动，例如优惠券或商品折扣',
    discountRefundsTip: '退还给商家的折扣金额',
    returnShippingTip: '商家因退货配送而支付的运费。',
    returnShippingCompensationTip: '平台赞助的退货运费补贴，包含在向客户提供的免费退货服务中。',
    commissionTip:
      '佣金的计算方式为：(净销售额 + 客户运费 - 客户运费退款) * 费率%。费率因商品类目而异。对于取消、退货或退款的订单，佣金费将按比例退还。',
    logisticsTip: '对通过自有物流承运商发货的订单收取的服务费，适用于不满足费用豁免条件的包裹。',
    marketingTip: '此费用包含来自HURIX的资金，用于向客户开展促销活动。',
    overview: '概览',
    overviewDescription: '了解并管理店铺的付款和对账单。',
    overviewTab: '财务概览',
    payments: '付款',
    statements: '结算单',
    unsettled: '未结算',
    invoice: '发票',
    tabs: '财务页签',
    all: '全部',
    paid: '已付款',
    failed: '失败',
    processing: '处理中',
    returned: '已退回',
    paymentStatus: '付款状态',
    status: '状态',
    actions: '操作',
    viewDetails: '查看详情',
    viewAll: '查看全部',
    close: '关闭',
    cancel: '取消',
    download: '下载',
    export: '导出',
    exportHistory: '导出历史记录',
    exportedReports: '已导出报告',
    filename: '文件名称',
    exportRange: '请选择导出的时间范围',
    startDate: '开始日期',
    endDate: '结束日期',
    exportRangeHint: '每次最多可以导出 90 天的数据。你可以在“导出记录”下查看所有导出报告。',
    historyHint: '已导出文件将保留 24 小时。超过该时限后，需重新导出。',
    noReports: '暂无工单',
    noExportData: '所选时间范围内暂无可导出数据',
    timezoneNotice: '自 2025/10/23 起，系统将根据你运营区域的时区处理报告',
    searchPayout: '搜索付款单 ID',
    searchBill: '搜索结算单 ID',
    searchOrder: '搜索订单 / 调整单 ID',
    selectPaymentDate: '付款日期',
    selectSettlementDate: '结算日期',
    selectCreatedDate: '订单创建日期',
    selectStatus: '选择状态',
    selectType: '选择类型',
    selectReason: '选择结算单未结算的原因',
    selectExpectedAmount: '选择预计结算金额',
    under100: '小于 £100',
    '100to500': '£100 至 £500',
    over500: '大于 £500',
    paymentDetails: '付款详情',
    paymentInfo: '付款信息',
    payoutId: '付款单 ID',
    paymentAmount: '付款金额',
    paymentDate: '付款开始日期',
    paidDate: '到账日期',
    reference: '注意',
    initiated: '已发起发款',
    bankConfirmed: '银行已确认',
    noPayments: '暂无付款记录',
    recentPayouts: '最近出款',
    recentPayoutsTips: '所选时间段内的发款记录。',
    recentProcessing: '最近处理中的出款',
    paymentsLoadFailed: '付款记录加载失败',
    statementsDescription: '每日报告将详细列出每笔已结算订单的明细，包括收入、退款、费用和调整金额。',
    byBill: '按结算单查看',
    byOrder: '按订单查看',
    settledOrders: '已结算订单',
    billId: '结算单 ID',
    settlementDate: '结算日期',
    settlementAmount: '结算金额',
    breakdown: '结算明细',
    netSales: '净销售额',
    totalSales: '总销售额',
    shipping: '运费',
    fees: '费用',
    adjustments: '调整',
    noBills: '暂无结算单',
    statementsLoadFailed: '结算单加载失败',
    orderId: '订单 / 调整单 ID',
    createdAt: '订单创建日期',
    deliveredAt: '订单送达日期',
    order: '订单',
    adjustment: '调整单',
    skuName: 'SKU 名称',
    skuId: 'SKU ID',
    skuDetails: 'SKU 详情',
    noOrders: '暂无匹配的订单 / 调整单',
    product: '商品',
    productName: '商品名称',
    quantity: '数量',
    contentType: '内容类型',
    video: '视频',
    unsettledDescription:
      '近期订单中尚未结算的款项。实际金额可能会因退款申请、退单拒付或运费调整而发生变化。',
    unsettledDetails: '未结算订单详情',
    expectedDate: '预计结算时间',
    expectedAmount: '预计结算金额',
    reason: '未结算原因',
    delivery: '待送达',
    refund: '等待完成退款 / 退货',
    settlement: '订单已送达，等待结算',
    afterDelivery: '送达后 {days} 天',
    ordersLoadFailed: '未结算订单加载失败',
    details: '详情',
    settlementPaymentDate: '结算日期（付款开始日期）',
    commission: '平台佣金费',
    logistics: '物流服务费',
    marketing: '智能营销费',
    grandTotal: '结算总金额',
    breakdownTip: '具体金额以当前结算单的订单明细为准。',
    formula: '结算总金额 = 净销售额 + 运费 + 费用 + 调整。费用项目以结算单内实际列出的明细为准。',
    learnCalculation: '详细了解我们如何计算结算明细',
    noSettlementRecords: '暂无结算记录',
    loadDetailsFailed: '结算明细加载失败，请重试',
    retry: '重新加载',
    ordersAndAdjustments: '订单和调整单',
    missingBill: '未找到该结算单，请通过面包屑返回财务页面重新选择。',
    financeDetailsFailed: '结算单详情加载失败，请重试',
    paymentCycle: '付款周期',
    cycleDescription:
      '选择你的付款周期。为简化财务相关工作并减少银行交易次数，建议付款频次选择每周或每月。',
    cycleLearnMore:
      '每周按选定的星期处理付款；每月按选定日期处理付款。若当月不存在该日期，则在当月最后一个有效日期处理。',
    learnMore: '了解更多',
    frequency: '频率',
    daily: '每天',
    workday: '每个工作日',
    weekly: '每周',
    monthly: '每月',
    dailyDescription: '付款会在每个自然日处理。',
    workdayDescription: '付款会在周一到周五处理，公共假期除外。',
    weeklyDescription: '付款将于你选择的日期每周处理一次。',
    monthlyDescription:
      '付款将于你选择的日期每月处理一次。如果所选日期在某月中不存在（如 31 日），系统将在该月最后一个有效日期自动处理发款。',
    recommended: '推荐',
    cycleDate: '日期',
    searchCycleDate: '输入内容进行搜索',
    submit: '提交',
    cycleSaveFailed: '付款周期保存失败，请重试',
    weeklyOn: '每周（{day}）',
    monthlyOn: '每月（{day} 日）',
    weekday1: '周一',
    weekday2: '周二',
    weekday3: '周三',
    weekday4: '周四',
    weekday5: '周五',
    weekday6: '周六',
    weekday7: '周日',
    custom: '自定义',
    thisWeek: '本周',
    lastWeek: '上周',
    lastMonth: '上个月',
    paymentFrequency: '付款频次',
    financialStatus: '财务状态',
    netIncome: '净收益',
    netIncomeTip: '结算所有平台费用后你将收得的金额。你可以自定义发款排期，或将这些资金用于支付平台其他费用。',
    received: '已到账',
    receivedTip: '成功转入主要银行账号的金额。',
    inProgress: '正在处理',
    processingEstimate: '预计 1–3 个工作日',
    processingTip: '银行正在处理你的发款，预计 1-3 个工作日到账。',
    toDate: '迄今',
    unsettledTip: '近期订单中尚未结算的款项。实际金额可能会因退款申请、退单拒付或运费调整而发生变化。',
    currentCycleNotice: '当前付款周期为{frequency}。建议采取以下措施，尽量减少潜在的余额风险：',
    cycleSuggestion: '为简化财务相关工作并减少银行交易次数，建议将发款频次选择每周或每月。',
    manageCycle: '管理付款周期',
    recentBills: '最近的账单',
    noContent: '暂无内容',
    recentPaymentHint: '此处显示近期付款信息。',
    dailyPaymentChart: '每日付款金额柱状图',
    currentSettlementCycle: '当前结算周期',
    settlementCycleTip: '订单送达后进入结算周期，具体到账时间以实际结算结果为准。',
    deferredCycle: '延期结算周期',
    unlockFaster: '如何解锁更快付款',
    reserveLevel: '储备金等级',
    level: '级别 {level}',
    reserveRules: '储备金使用规则',
    unsettledChart: '未结算金额及原因分布环形图',
    paymentSettings: '付款设置',
    accountHint: '若要通过新结算账号收款，请将其设为主账号。',
    settlementAccount: '结算账号',
    valid: '有效',
    learnFinance: '了解财务信息',
    whenPaid: '我什么时候能收到付款？',
    whenPaidAnswer:
      '订单满足结算条件后，平台会根据当前付款周期安排出款。银行通常需要 1–3 个工作日完成处理，周末和节假日可能顺延。',
    commissionQuestion: '平台收取的佣金是如何计算的？',
    commissionAnswer:
      '佣金按订单适用的费率及结算金额计算，退款、商家折扣和费用调整会影响最终付款金额。可在结算单页签查看对应期间的明细。',
    overviewLoadFailed: '财务概览加载失败，请稍后重试',
    salesRefunds: '销售退款总额',
    sellerDiscounts: '商家折扣',
    discountRefunds: '商家折扣退款',
    netShipping: '净运费',
    returnShipping: '退货运费',
    returnShippingCompensation: '退货运费补偿',
    awaitDelivery: '等待包裹妥投',
    awaitRefund: '等待退货 / 退款申请处理完成',
    processingAmountTip: '已发起付款，预计 1–3 个工作日到账。',
    paidAmountTip: '付款金额是扣除所有费用、调整和预留金后，您最终获得的总金额。当您的每天的付款金额大于等于£1.00后，HURIX 会发起付款。',
    paymentComposition: '付款金额构成',
    unsettledOrderInformation: '未结算订单的详细信息',
    noUnsettledOrders: '暂无未结算订单',
    pendingSettlement: '待结算',
    orderNumber: '订单编号',
    createDate: '创建日期'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js